/* [RR feat] Abo-Portal „Meine Abos" – Appstle Storefront API über den Shopify App Proxy.
   Endpunkt-Referenz: docs/appstle-storefront-api.md */
(function () {
  'use strict';

function mount() {
  /* Jeder Mount bekommt eine Nummer – Listener älterer Mounts (Theme-Editor lädt die Section neu) bleiben stumm */
  var MOUNT = window.__rrpMount = (window.__rrpMount || 0) + 1;
  var root = document.querySelector('.rrp[data-section-id]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var cfgEl = document.getElementById('rrp-config-' + sectionId);
  var app = document.getElementById('rrp-app-' + sectionId);
  if (!cfgEl || !app) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ---------- Hilfsfunktionen ---------- */
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MON_S = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  var MON_XS = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  var DAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var DAYS_S = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(id) {
    if (id == null) return null;
    var m = String(id).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }
  function money(n) {
    var v = Number(n || 0);
    return v.toFixed(2).replace('.', ',') + ' €';
  }
  function parseDate(v) {
    if (!v) return null;
    if (v instanceof Date) return v;
    var d = new Date(v);
    if (isNaN(d.getTime())) {
      var m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }
    return isNaN(d.getTime()) ? null : d;
  }
  /* Datum im Appstle-Format (z. B. DD-MM-YYYY) lesen */
  function parseByFormat(str, fmt) {
    if (!str) return null;
    var parts = String(str).match(/\d+/g);
    if (!parts || parts.length < 3) return null;
    var tokens = ['YYYY', 'MM', 'DD'].map(function (tk) { return { tk: tk, i: String(fmt || 'DD-MM-YYYY').indexOf(tk) }; })
      .filter(function (x) { return x.i >= 0; }).sort(function (a, b) { return a.i - b.i; });
    if (tokens.length < 3) return null;
    var v = {};
    tokens.forEach(function (x, idx) { v[x.tk] = Number(parts[idx]); });
    if (v.YYYY < 100) v.YYYY += 2000;
    var d = new Date(v.YYYY, v.MM - 1, v.DD);
    return isNaN(d.getTime()) ? null : d;
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function fmtShort(d) { return d ? DAYS_S[d.getDay()] + ', ' + d.getDate() + '. ' + MON_S[d.getMonth()] : '–'; }
  function fmtLong(d) { return d ? DAYS[d.getDay()] + ', ' + d.getDate() + '. ' + MONTHS[d.getMonth()] : '–'; }
  function dayKey(d) { return d ? d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() : ''; }
  function unwrap(res) {
    if (res && typeof res === 'object' && !Array.isArray(res)) {
      if (Array.isArray(res.content)) return res.content;
      if (Array.isArray(res.data)) return res.data;
      if (Array.isArray(res.nodes)) return res.nodes;
      if (Array.isArray(res.edges)) return res.edges.map(function (e) { return e.node || e; });
    }
    return Array.isArray(res) ? res : [];
  }
  function intervalDays(policy) {
    if (!policy) return 7;
    var c = Number(policy.intervalCount || 1);
    var unit = String(policy.interval || 'WEEK').toUpperCase();
    return unit === 'DAY' ? c : unit === 'MONTH' ? c * 30 : unit === 'YEAR' ? c * 365 : c * 7;
  }
  function rhythmLabel(policy) {
    if (!policy) return '';
    var c = Number(policy.intervalCount || 1);
    var unit = String(policy.interval || 'WEEK').toUpperCase();
    if (unit === 'WEEK') return c === 1 ? 'Jede Woche' : c === 2 ? 'Alle 14 Tage' : 'Alle ' + c + ' Wochen';
    if (unit === 'DAY') return c === 7 ? 'Jede Woche' : c === 14 ? 'Alle 14 Tage' : 'Alle ' + c + ' Tage';
    if (unit === 'MONTH') return c === 1 ? 'Jeden Monat' : 'Alle ' + c + ' Monate';
    return c === 1 ? 'Jedes Jahr' : 'Alle ' + c + ' Jahre';
  }

  var ICON = {
    back: '<svg class="rrp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 19-7-7 7-7M19 12H5"/></svg>',
    pin: '<svg class="rrp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    box: '<svg class="rrp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 9.4 7.55 4.24"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="M3.29 7 12 12l8.71-5"/><path d="M12 22V12"/></svg>',
    cal: '<svg class="rrp-icon rrp-icon--md" viewBox="0 0 24 24" fill="none" stroke="#022519" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',
    card: '<svg class="rrp-icon rrp-icon--md" viewBox="0 0 24 24" fill="none" stroke="#022519" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>',
    pinMd: '<svg class="rrp-icon rrp-icon--md" viewBox="0 0 24 24" fill="none" stroke="#022519" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    close: '<svg class="rrp-icon rrp-icon--md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    arrowL: '<svg class="rrp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    arrowR: '<svg class="rrp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    star: '<svg class="rrp-icon rrp-icon--md" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 17.7 6 21l1.3-6.8-5-4.7 6.8-.8z"/></svg>',
    friends: '<svg class="rrp-icon rrp-icon--md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M21.5 20a6.5 6.5 0 0 0-4.5-6.2"/></svg>'
  };

  /* ---------- Appstle-Client ---------- */
  var API_BASE = String(cfg.proxyPath).replace(/\/+$/, '') + '/cp/api';

  /* Beschriftung einer Rhythmus-Option, wie Appstle sie je nach Endpunkt anders benennt. */
  function freqLabel(f) {
    if (!f) return '';
    return f.name || f.label || f.frequencyName || f.sellingPlanName ||
      rhythmLabel({ interval: f.interval || f.billingInterval, intervalCount: f.intervalCount || f.billingIntervalCount });
  }
  /* Laeuft das Abo bereits in diesem Rhythmus? */
  function istAktiverRhythmus(c, f) {
    if (!c || !f) return false;
    if (f.selected === true || f.current === true) return true;
    if (c.box && f.sellingPlanId && num(f.sellingPlanId) === num(c.box.sellingPlanId)) return true;
    return !f.sellingPlanId && freqLabel(f) === rhythmLabel(c.billingPolicy || c.deliveryPolicy);
  }

  function buildQuery(q) {
    if (!q) return '';
    var parts = [];
    Object.keys(q).forEach(function (k) {
      if (q[k] === undefined || q[k] === null || q[k] === '') return;
      parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(q[k]));
    });
    return parts.length ? '?' + parts.join('&') : '';
  }

  function api(method, path, opts) {
    opts = opts || {};
    if (cfg.designMode) { var de = new Error('Im Theme-Editor ist das Portal nur eine Vorschau mit Beispieldaten.'); de.status = 0; return Promise.reject(de); }
    var url = (opts.base || API_BASE) + path + buildQuery(opts.query);
    var init = { method: method, credentials: 'same-origin', headers: Object.assign({ 'Accept': 'application/json' }, opts.headers || {}) };
    if (opts.body !== undefined) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(opts.body);
    }
    return fetch(url, init).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        if (text) { try { data = JSON.parse(text); } catch (e) { data = text; } }
        if (!res.ok) {
          var msg = (data && typeof data === 'object' && (data.message || data.detail || data.title || data.error)) || (typeof data === 'string' && data.slice(0, 200)) || ('Fehler ' + res.status);
          var err = new Error(msg);
          err.status = res.status;
          err.data = data;
          state.lastError = { method: method, url: url, status: res.status, body: typeof data === 'string' ? data.slice(0, 600) : JSON.stringify(data).slice(0, 600) };
          try { console.warn('[Abo-Portal] Appstle-Fehler', state.lastError); } catch (e) {}
          throw err;
        }
        return data;
      });
    });
  }

  var Appstle = {
    validIds: function (cid) { return api('GET', '/subscription-customers/valid/' + cid); },
    contract: function (id) { return api('GET', '/subscription-contracts/contract-external/' + id); },
    upcoming: function (id) { return api('GET', '/subscription-billing-attempts/top-orders', { query: { contractId: id } }); },
    past: function (id) { return api('GET', '/subscription-billing-attempts/past-orders', { query: { contractId: id, page: 0, size: 12, sort: 'billingDate,desc' } }); },
    fulfillments: function (id) { return api('GET', '/subscription-contract-details/subscription-fulfillments/' + id); },
    skip: function (id, attemptId) { return api('PUT', '/subscription-billing-attempts/skip-order/' + attemptId, { query: { subscriptionContractId: id } }); },
    unskip: function (id, attemptId) { return api('PUT', '/subscription-billing-attempts/unskip-order/' + attemptId, { query: { subscriptionContractId: id } }); },
    skipUpcoming: function (id) { return api('PUT', '/subscription-billing-attempts/skip-upcoming-order', { query: { contractId: id } }); },
    status: function (id, status, extra) { return api('PUT', '/subscription-contracts-update-status', { query: Object.assign({ contractId: id, status: status }, extra || {}) }); },
    cancel: function (id, feedback, note) { return api('DELETE', '/subscription-contracts/' + id, { query: { cancellationFeedback: feedback, cancellationNote: note } }); },
    frequencies: function (id) { return api('GET', '/data/v2/compatible-selling-plan-frequencies', { query: { contractId: id } }); },
    setFrequency: function (id, opt) {
      if (opt.frequencyKey) return api('PUT', '/subscription-contracts-update-frequency-by-compatible-plan', { query: { contractId: id, frequencyKey: opt.frequencyKey, sellingPlanId: opt.sellingPlanId } });
      /* Verkaufsplan aus dem Theme (Liquid) gewählt: Vertrag auf diesen Selling Plan umstellen */
      return api('PUT', '/subscription-contracts-update-frequency-by-selling-plan', { query: { contractId: id, sellingPlanId: opt.sellingPlanId } });
    },
    replaceVariant: function (id, line, newVariantId) {
      /* 1. Versuch: Appstle „replace-variants-v3“ (alte/neue Varianten als Listen, Ziel-Zeile über oldLineId, Mengen
         in allen gängigen Schreibweisen; Parameter als Query UND JSON-Body).
         Schlägt das fehl (z. B. Shopify: „Contract draft must have at least one line“, weil Appstle die alte Zeile
         entfernt, die neue aber nicht anlegt), läuft der Tausch zweistufig über die einfachen Endpunkte:
         erst neue Box als Abo-Zeile hinzufügen, dann die bisherige Zeile entfernen. So gibt es nie einen leeren Vertrag. */
      var qty = Number(line.quantity) || 1;
      var params = {
        contractId: id,
        oldVariantIds: [line.variantId], newVariantIds: [newVariantId],
        oldVariantId: line.variantId, newVariantId: newVariantId,
        oldLineId: line.lineId, lineId: line.lineId,
        quantity: qty, quantities: [qty], newQuantity: qty,
        isOneTimeProduct: false,
        discountCarryForward: 'PRODUCT_THEN_EXISTING'
      };
      var query = Object.assign({}, params, { oldVariantIds: params.oldVariantIds.join(','), newVariantIds: params.newVariantIds.join(','), quantities: params.quantities.join(',') });
      return api('POST', '/subscription-contract-details/replace-variants-v3', { query: query, body: params }).then(null, function (err) {
        var st = err && err.status;
        if (st === 401 || st === 403) throw err;
        try { console.warn('[Abo-Portal] replace-variants-v3 fehlgeschlagen, tausche zweistufig', err && err.message); } catch (e) {}
        return Appstle.swapTwoStep(id, line, newVariantId, qty);
      });
    },
    swapTwoStep: function (id, line, newVariantId, qty) {
      return Appstle.addLine(id, newVariantId, qty, false).then(function () {
        return Appstle.removeLine(id, line.lineId).then(null, function (err) {
          var e = new Error('Die neue Box ist drin, die bisherige konnte aber nicht entfernt werden (' + fehlerDetail(err) + '). Bitte melde dich kurz bei uns.');
          e.status = err && err.status; e.partial = true;
          throw e;
        });
      });
    },
    addLine: function (id, variantId, qty, oneTime) {
      return api('PUT', '/v2/subscription-contracts-add-line-item', { query: { contractId: id, variantId: variantId, quantity: qty, isOneTimeProduct: oneTime !== false } });
    },
    lineQty: function (id, lineId, qty) { return api('PUT', '/subscription-contracts-update-line-item-quantity', { query: { contractId: id, lineId: lineId, quantity: qty } }); },
    removeLine: function (id, lineId) { return api('PUT', '/subscription-contracts-remove-line-item', { query: { contractId: id, lineId: lineId, removeDiscount: true } }); },
    /* [RR feat] Treuepunkte: eingeloesten Rabattcode auf den Vertrag legen (docs/appstle-storefront-api.md, Rabatte) */
    applyDiscount: function (id, code) { return api('PUT', '/subscription-contracts-apply-discount', { query: { contractId: id, discountCode: code } }); },
    address: function (id, addr) { return api('PUT', '/subscription-contracts-update-shipping-address', { query: { contractId: id }, body: addr }); },
    note: function (id, note) { return api('PUT', '/subscription-contracts-update-order-note/' + id, { query: { orderNote: note }, body: { orderNote: note } }); },
    /* [RR feat] Vertragsattribute setzen; bestehende bleiben erhalten (Merge). Appstle schreibt sie auf jede Folgebestellung. */
    attributes: function (id, list) { return api('POST', '/update-custom-note-attributes', { query: { overwriteExistingAttributes: false }, body: { subscriptionContractId: id, customAttributesList: list, overwriteExistingAttributes: false } }); },
    paymentEmail: function (id) { return api('PUT', '/subscription-contracts-update-payment-method', { query: { contractId: id } }); }
  };

  /* ---------- Modell ---------- */
  var boxVariants = {}; (cfg.boxes || []).forEach(function (b) { boxVariants[b.id] = b; });
  var extraVariants = {}; (cfg.extras || []).forEach(function (x) { extraVariants[x.id] = x; });


  /* ---------- [RR feat] Treuepunkte (Appstle Loyalty) ----------
     Anzeige aus dem Kunden-Metafeld appstle_loyalty.customer_loyalty (sofort da, kann ein paar
     Minuten alt sein), Aktionen und frischer Stand ueber den App-Proxy /apps/loyalty/cp/api.
     Nur fuer eingeloggte Kund:innen, Shopify signiert die Anfrage. Referenz: docs/appstle-loyalty-api.md */
  var LOY = cfg.loyalty || {};
  /* Appstle liefert den Pfad als "apps/loyalty" (ohne fuehrenden Schraegstrich); hier wird er normalisiert */
  var LOY_BASE = '/' + String(LOY.proxyPath || 'apps/loyalty').replace(/^\/+|\/+$/g, '') + '/cp/api';
  function loyOn() { return !!LOY.enabled; }
  function loyApi(method, path, opts) {
    opts = Object.assign({}, opts || {});
    opts.base = LOY_BASE;
    /* Appstle verlangt den Header bei allem ausser GET */
    if (method !== 'GET') opts.headers = { 'X-Requested-With': 'XMLHttpRequest' };
    return api(method, path, opts);
  }
  /* Punkte sind bei uns Bruchzahlen (0,067 je Euro): hoechstens zwei Nachkommastellen, keine Nullen am Ende */
  function punkteFmt(n) {
    var v = Math.round(Number(n || 0) * 100) / 100;
    var s = v.toFixed(2).replace(/\.?0+$/, '');
    return s.replace('.', ',');
  }
  function punkteWort(n) { return punkteFmt(n) + (Math.round(Number(n || 0) * 100) === 100 ? ' Punkt' : ' Punkte'); }
  function loyRules() {
    return (LOY.redeemRules || []).filter(function (r) { return r && r.status !== 'INACTIVE' && !r.referralType && Number(r.redeemPoints) > 0; })
      .sort(function (a, b) { return Number(a.redeemPoints) - Number(b.redeemPoints); });
  }
  function loyEarn() { return (LOY.earnRules || []).filter(function (r) { return r && r.status !== 'INACTIVE'; }); }
  function ruleTitel(r) {
    var d = Number(r.discount || 0);
    if (r.type === 'FREE_PRODUCT' || r.discountType === 'FREE_PRODUCT') return r.name || 'Gratis-Produkt';
    if (r.type === 'FREE_SHIPPING' || r.discountType === 'FREE_SHIPPING') return 'Versand gratis';
    if (r.type === 'STORE_CREDIT') return money(d) + ' Guthaben';
    if (r.discountType === 'PERCENTAGE') return punkteFmt(d) + ' % Rabatt';
    if (d > 0) return money(d) + ' Rabatt';
    return r.name || 'Belohnung';
  }
  function ruleZeile(r) {
    var t = [punkteWort(r.redeemPoints)];
    if (Number(r.minimumPurchaseAmount) > 0) t.push('ab ' + money(r.minimumPurchaseAmount) + ' Bestellwert');
    if (r.appliesOn === 'SUBSCRIPTION') t.push('für Abo-Lieferungen');
    return t.join(' · ');
  }
  /* Naechste Belohnung, fuer die es noch nicht reicht, und die beste, die schon geht */
  function loyNext(avail) {
    var rules = loyRules();
    var next = rules.filter(function (r) { return Number(r.redeemPoints) > avail; })[0] || null;
    var ready = rules.filter(function (r) { return Number(r.redeemPoints) <= avail; });
    return { next: next, ready: ready, best: ready[ready.length - 1] || null, pct: next ? Math.min(100, Math.round(avail / Number(next.redeemPoints) * 100)) : 100 };
  }
  function earnZeile(r) {
    var bp = Number(r.basePoints || 0);
    var min = Number(r.minimumOrderValue || 0) > 0 ? ' (ab ' + money(r.minimumOrderValue) + ')' : '';
    if (r.type === 'SUBSCRIPTION' || r.type === 'PURCHASE') {
      var was = r.type === 'SUBSCRIPTION' ? 'Abo-Bestellwert' : 'Bestellwert';
      if (bp > 0 && bp < 1) return { was: 'Jede Lieferung', wie: '1 Punkt je ' + Math.round(1 / bp) + ' € ' + was + min };
      if (bp >= 1) return { was: 'Jede Lieferung', wie: punkteWort(bp) + ' je 1 € ' + was + min };
    }
    var FIX = { CREATE_ACCOUNT: 'Konto anlegen', SIGNUP: 'Konto anlegen', BIRTHDAY: 'Dein Geburtstag', REVIEW: 'Bewertung schreiben', PRODUCT_REVIEW: 'Bewertung schreiben', JUDGE_ME_REVIEW: 'Bewertung schreiben', NEWSLETTER: 'Newsletter abonnieren' };
    if (FIX[r.type]) return { was: FIX[r.type], wie: punkteWort(bp) };
    return { was: r.name || r.type || 'Aktion', wie: bp ? punkteWort(bp) : (r.customerFacingLabel || '') };
  }
  /* Was die naechste Lieferung bringt: Punkte je Euro mal Box und Extras des ersten laufenden Abos */
  function loyVoraus() {
    var rule = loyEarn().filter(function (r) { return r.type === 'SUBSCRIPTION' && Number(r.basePoints) > 0; })[0];
    var c = state.contracts.filter(function (x) { return x.status === 'ACTIVE'; })[0];
    if (!rule || !c) return null;
    var summe = boxPrice(c) + (c.extras || []).reduce(function (t, l) { return t + l.lineTotal; }, 0);
    if (rule.includeShippingPoints) summe += (c.shipping || 0);
    if (summe <= 0 || summe < Number(rule.minimumOrderValue || 0)) return null;
    return { punkte: summe * Number(rule.basePoints), datum: deliveryDate(c) };
  }
  function loyReferralText() {
    var ref = LOY.referral || {};
    var de = function (s) { s = String(s == null ? '' : s).trim(); return s.replace(/^(\d+(?:[.,]\d+)?)\s*points?$/i, function (m, n) { return punkteWort(n.replace(',', '.')); }).replace(/^(\d+)%$/, '$1 %'); };
    var du = de(ref.referralGet), sie = de(ref.referredGet);
    if (sie === '0' || sie === '0 Punkte') sie = '';
    if (du === '0' || du === '0 Punkte') du = '';
    return { du: du, sie: sie, wann: ref.referralType === 'CREATE_ACCOUNT' ? 'sobald sie ein Konto anlegt' : 'sobald ihre erste Box bezahlt ist' };
  }
  function rewardsOffen(d) { return ((d && d.rewards) || []).filter(function (r) { return r.status === 'UNUSED' || r.status === 'SUBSCRIPTION_ACTIVE'; }); }
  /* Appstle schickt zur Belohnung nur seinen englischen Standardtext; der Titel kommt deshalb aus der Regel */
  function rewardRegel(r) {
    return (LOY.redeemRules || []).filter(function (x) { return x && Number(x.id) === Number(r.pointRedeemRuleId); })[0] || null;
  }
  function rewardTitel(r) {
    var regel = rewardRegel(r);
    if (regel) return ruleTitel(regel);
    if (r.rewardType === 'STORE_CREDIT') return money(r.amount) + ' Guthaben';
    if (Number(r.amount) > 0) return money(r.amount) + ' Rabatt';
    var m = String(r.description || '').match(/(\d+(?:[.,]\d{1,2})?)\s*%/) ? null : String(r.description || '').match(/(\d+(?:[.,]\d{1,2})?)/);
    if (m) return money(m[1].replace(',', '.')) + ' Rabatt';
    return 'Belohnung';
  }
  function rewardZeile(r) {
    var regel = rewardRegel(r), t = [];
    if (regel && Number(regel.minimumPurchaseAmount) > 0) t.push('ab ' + money(regel.minimumPurchaseAmount) + ' Bestellwert');
    if (regel && regel.appliesOn === 'SUBSCRIPTION') t.push('für Abo-Lieferungen');
    var exp = parseDate(r.expireDate);
    if (exp) t.push('gültig bis ' + fmtShort(exp));
    return t.join(' · ');
  }
  function aktiveAbos() { return state.contracts.filter(function (c) { return c.status === 'ACTIVE' || c.status === 'FAILED'; }); }
  function codeAufAbo(code) {
    var k = String(code || '').trim().toLowerCase();
    if (!k) return null;
    return state.contracts.filter(function (c) {
      return (c.discounts || []).some(function (d) { return d.title.trim().toLowerCase() === k && !d.rejectionReason; });
    })[0] || null;
  }
  function loyFehler(err) {
    var data = err && err.data;
    var key = data && typeof data === 'object' ? (data.errorKey || data.error || data.message) : null;
    var MAP = {
      rewardReturnDisabled: 'Zurückgeben ist in unserem Programm nicht vorgesehen. Der Code bleibt dir erhalten.',
      rewardNotUnused: 'Dieser Code ist schon benutzt und lässt sich nicht mehr zurückgeben.',
      rewardNotReturnable: 'Diese Belohnung lässt sich nicht zurückgeben.',
      rewardExpired: 'Diese Belohnung ist schon abgelaufen.',
      rewardUsageUnverified: 'Wir konnten gerade nicht prüfen, ob der Code schon benutzt wurde. Gleich noch einmal versuchen.',
      rewardActionInProgress: 'Da läuft gerade schon etwas. Gleich noch einmal versuchen.',
      'Insufficient points': 'Dafür reichen deine Punkte noch nicht.'
    };
    if (key && MAP[key]) return MAP[key];
    if (err && err.status === 429) return 'Das waren gerade zu viele Einladungen auf einmal. Morgen geht es weiter.';
    return fehlerText(err);
  }
  function kopieren(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (ok, nein) {
      var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var geklappt = false; try { geklappt = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      geklappt ? ok() : nein(new Error('copy'));
    });
  }
  function unwrapPage(res) { return unwrap(res); }
  /* Frischen Stand, Verlauf und Werbungen holen. Laeuft hoechstens einmal, ausser neu = true. */
  function loyLaden(neu) {
    if (!loyOn() || !cfg.customerId || cfg.designMode) return Promise.resolve();
    if (state.loy.geladen && !neu) return Promise.resolve();
    if (state.loy.laeuft) return state.loy.laeuft;
    state.loy.laden = true; state.loy.fehler = null;
    var seite = { query: { page: 0, size: 12, sort: 'id,desc' } };
    var p = Promise.all([
      loyApi('GET', '/customer-loyalty').then(function (res) {
        if (res && typeof res === 'object' && 'availablePoints' in res) { state.loy.data = res; state.loy.fehlt = false; }
        else if (!state.loy.data) state.loy.fehlt = true;
      }, function (err) {
        if (err && (err.status === 400 || err.status === 404)) { if (!state.loy.data) state.loy.fehlt = true; }
        else if (!state.loy.data) state.loy.fehler = (err && err.message) || 'Unbekannter Fehler';
      }),
      loyApi('GET', '/transaction-by-shop', seite).then(function (res) { state.loy.verlauf = unwrapPage(res); }, function () { state.loy.verlauf = []; }),
      LOY.referralEnabled ? loyApi('GET', '/customer-referrals', seite).then(function (res) { state.loy.referrals = unwrapPage(res); }, function () { state.loy.referrals = []; }) : Promise.resolve()
    ]).then(function () { state.loy.laden = false; state.loy.geladen = true; state.loy.laeuft = null; });
    state.loy.laeuft = p;
    return p;
  }
  function zeigeTab(tab) {
    tab = (tab === 'punkte' || tab === 'werben') && loyOn() ? tab : 'abos';
    if (tab === 'werben' && !LOY.referralEnabled) tab = 'punkte';
    state.tab = tab; state.selectedId = null; state.dialog = null; state.dialogData = {}; state.boxProduct = null;
    try { history.replaceState(null, '', location.pathname + (tab === 'abos' ? '' : '?tab=' + tab)); } catch (e) {}
    window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    render();
    if (tab !== 'abos') loyLaden(false).then(function () { if (!state.dialog) render(); }, function () { render(); });
  }

  function normalizeContract(raw, fallback) {
    raw = raw || {};
    var lines = unwrap(raw.lines).map(function (l) {
      var attrs = {};
      (l.customAttributes || []).forEach(function (a) { if (a && a.key) attrs[a.key] = a.value; });
      var price = l.currentPrice ? Number(l.currentPrice.amount) : (l.price != null ? Number(l.price) : 0);
      return {
        lineId: l.id, variantId: num(l.variantId), productId: num(l.productId),
        title: l.title || l.productTitle || '', variantTitle: (l.variantTitle && l.variantTitle !== 'Default Title') ? l.variantTitle : '',
        quantity: Number(l.quantity || 1), price: price, lineTotal: l.lineDiscountedPrice ? Number(l.lineDiscountedPrice.amount) : price * Number(l.quantity || 1),
        sellingPlanId: l.sellingPlanId, attrs: attrs,
        isExtra: !!extraVariants[num(l.variantId)]
      };
    });
    var box = lines.filter(function (l) { return boxVariants[l.variantId]; })[0] || lines.filter(function (l) { return !l.isExtra; })[0] || lines[0] || null;
    var extras = lines.filter(function (l) { return l.isExtra; });
    var dm = raw.deliveryMethod || {};
    /* [RR feat] Versandpreis des Vertrags. Seit der Umstellung auf 3,99 EUR je
       Paket darf das Portal nicht mehr nur Positionspreise zeigen, sonst steht
       hier 22,99 und in der Bestellhistorie 26,98. Der Wert steht am Vertrag,
       nicht am Produkt - Altvertraege fuehren weiterhin 0,00. Appstle liefert
       ihn je nach Endpunkt an unterschiedlicher Stelle, daher die Kette. */
    var versand = 0;
    if (raw.deliveryPrice && raw.deliveryPrice.amount != null) versand = Number(raw.deliveryPrice.amount);
    else if (dm.deliveryPrice && dm.deliveryPrice.amount != null) versand = Number(dm.deliveryPrice.amount);
    else if (dm.shippingOption && dm.shippingOption.price && dm.shippingOption.price.amount != null) versand = Number(dm.shippingOption.price.amount);
    if (!isFinite(versand) || versand < 0) versand = 0;
    var addr = dm.address || (raw.deliveryAddress) || {};
    var pm = raw.customerPaymentMethod || {};
    var inst = pm.instrument || {};
    var status = String(raw.status || (fallback && fallback.status) || 'ACTIVE').toUpperCase();
    var id = num(raw.id) || (fallback && num(fallback.id));
    var next = parseDate(raw.nextBillingDate || (fallback && fallback.nextBillingDate));
    var attrs = box ? box.attrs : {};
    var cattrs = {};
    (raw.customAttributes || []).forEach(function (a) { if (a && a.key) cattrs[a.key] = a.value; });
    var attrName = cfg.deliveryAttribute || 'Liefertermin';
    var attrDate = parseByFormat(cattrs[attrName] || attrs[attrName] || '', cfg.deliveryDateFormat);
    return {
      id: id, status: status,
      nextBillingDate: next,
      createdAt: parseDate(raw.createdAt),
      billingPolicy: raw.billingPolicy || null, deliveryPolicy: raw.deliveryPolicy || null,
      lines: lines, box: box, extras: extras, shipping: versand,
      /* [RR feat] Treuepunkte: am Vertrag haengende Rabatte, um einen eingeloesten Code wiederzuerkennen */
      discounts: unwrap(raw.discounts).map(function (d) { return { id: d.id, title: String(d.title || ''), type: d.type || '', rejectionReason: d.rejectionReason || null, cycles: d.recurringCycleLimit, value: d.value || null }; }),
      address: {
        firstName: addr.firstName || '', lastName: addr.lastName || '', company: addr.company || '',
        address1: addr.address1 || '', address2: addr.address2 || '', city: addr.city || '', zip: addr.zip || '',
        province: addr.province || '', provinceCode: addr.provinceCode || '', country: addr.country || '', countryCode: addr.countryCode || addr.countryCodeV2 || '',
        phone: addr.phone || ''
      },
      payment: inst.lastDigits ? { brand: inst.brand || '', last4: inst.lastDigits, month: inst.expiryMonth, year: inst.expiryYear, type: inst.__typename || '' } : (inst.__typename ? { brand: inst.__typename.replace(/^Customer/, ''), last4: '', type: inst.__typename } : null),
      note: raw.note || '',
      deliveryDay: attrs['_Delivery Day'] || attrs['Lieferung'] || '',
      deliveryAttrDate: attrDate,
      /* [RR feat] Vorgemerkte Kuendigung: Attribut _rr_kuendigung = Liefertag (ISO), nach dem das Abo endet */
      attrs: cattrs,
      kuendigungZum: parseDate(cattrs[KUEND_KEY] || ''),
      attempts: null, history: null, frequencies: null
    };
  }

  function deliveryDate(c, billing) {
    /* Ohne konkreten Abrechnungstermin gilt der von Appstle gepflegte Liefertermin (Bestell-Attribut), sonst Abrechnung + Offset */
    if (!billing && c.deliveryAttrDate) {
      var today = new Date(); today.setHours(0, 0, 0, 0);
      if (c.deliveryAttrDate >= addDays(today, -1)) return c.deliveryAttrDate;
    }
    var d = billing || c.nextBillingDate;
    return d ? addDays(d, Number(cfg.deliveryOffsetDays || 0)) : null;
  }
  function boxTitle(c) {
    if (!c.box) return 'Abo';
    var b = boxVariants[c.box.variantId];
    return b ? b.product : c.box.title;
  }
  function boxSize(c) {
    if (!c.box) return '';
    var b = boxVariants[c.box.variantId];
    return b ? b.variant : c.box.variantTitle;
  }
  function boxPrice(c) { return c.box ? c.box.lineTotal : 0; }
  /* [RR feat] Was pro Lieferung wirklich abgebucht wird: Box, Extras, Versand.
     Ohne den Versand stimmt die Zahl im Portal nicht mit der Rechnung ueberein. */
  function lieferSumme(c) {
    var extras = c.extras.reduce(function (t, l) { return t + l.lineTotal; }, 0);
    var gesamt = boxPrice(c) + extras + (c.shipping || 0);
    var teile = [money(boxPrice(c)) + ' Box'];
    if (extras > 0) teile.push(money(extras) + ' Extras');
    teile.push(c.shipping > 0 ? money(c.shipping) + ' Versand' : 'Versand frei');
    return teile.join(' + ') + ' = ' + money(gesamt) + ' pro Lieferung';
  }
  function statusBadge(c, short) {
    if (c.status === 'ACTIVE') return ['green', short ? 'Aktiv' : 'Abo aktiv'];
    if (c.status === 'PAUSED') return ['yellow', 'Pausiert'];
    if (c.status === 'CANCELLED' || c.status === 'EXPIRED') return ['orange', 'Gekündigt'];
    if (c.status === 'FAILED') return ['orange', 'Zahlung offen'];
    return ['yellow', c.status];
  }
  function addressLine(c) {
    var a = c.address;
    var parts = [];
    if (a.address1) parts.push(a.address1);
    if (a.zip || a.city) parts.push([a.zip, a.city].filter(Boolean).join(' '));
    return parts.join(', ');
  }
  function queuedAttempts(c) {
    var seen = {}, out = [];
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var add = function (a, futureOnly) {
      var s = String(a.status || '').toUpperCase();
      if (!(s === 'QUEUED' || s === 'SKIPPED' || s === 'SCHEDULED' || s === 'PENDING')) return;
      var d = parseDate(a.billingDate); if (!d) return;
      if (futureOnly && d < today) return;
      var key = a.id != null ? String(a.id) : dayKey(d);
      if (seen[key]) return; seen[key] = 1; out.push(a);
    };
    (c.attempts || []).forEach(function (a) { add(a, false); });
    (c.history || []).forEach(function (a) { add(a, true); }); /* übersprungene Termine in der Zukunft */
    return out.sort(function (a, b) { return parseDate(a.billingDate) - parseDate(b.billingDate); });
  }
  /* Bisherige Lieferungen: nur Vergangenes (übersprungene Zukunftstermine stehen unter „Die nächsten Wochen“) */
  function pastAttempts(c) {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    return (c.history || []).filter(function (a) {
      var s = String(a.status || '').toUpperCase(), d = parseDate(a.billingDate || a.attemptTime);
      return s === 'SUCCESS' || s === 'FAILURE' || s === 'FAILED' || (d && d < today);
    });
  }
  function nextAttempt(c) {
    return queuedAttempts(c).filter(function (a) { return String(a.status).toUpperCase() !== 'SKIPPED'; })[0] || null;
  }
  /* --- Bestellschluss -------------------------------------------------------
     Ab cfg.cutoffDays Tagen vor der Lieferung steht der Inhalt fest: die
     Kommissionierliste ist raus. Der Kunde kann dann nichts mehr an dieser
     Lieferung aendern. Offen bleiben bewusst drei Dinge, siehe
     docs/abo-portal-bestellschluss.md: Adresse, Zahlart und Kuendigung. */
  function tage(v) {
    var n = Number(v);
    return isFinite(n) && n > 0 ? n : 0;
  }
  /* Wirksamer Bestellschluss in Tagen vor der Lieferung.

     Appstle hat einen eigenen Bestellschluss, der vom Abrechnungstermin aus
     zaehlt, nicht vom Liefertag. Umgerechnet sind das appstleCutoffDays plus
     Lieferabstand Tage vor der Lieferung. Der groessere der beiden Werte gilt,
     sonst bietet das Portal eine Schaltflaeche an, die Appstle anschliessend
     mit einem rohen Fehler ablehnt ("Sie koennen das Abonnement nicht vor
     4 Tagen ab Ihrem naechsten Bestelldatum kuendigen/anhalten"). */
  function cutoffTage() {
    var appstle = tage(cfg.appstleCutoffDays);
    /* Ohne Bestellschluss in Appstle gibt es auch nichts umzurechnen – der
       Lieferabstand allein darf keine Sperre erzeugen. */
    return Math.max(tage(cfg.cutoffDays), appstle ? appstle + tage(cfg.deliveryOffsetDays) : 0);
  }
  /* Letzter Liefertag, der noch als "in Vorbereitung" gilt. */
  function cutoffGrenze() {
    var t = new Date(); t.setHours(0, 0, 0, 0);
    return addDays(t, cutoffTage());
  }
  /* Liegt dieser Liefertag innerhalb des Bestellschlusses? */
  function terminGesperrt(d) {
    if (!cutoffTage() || !d) return false;
    var x = new Date(d); x.setHours(0, 0, 0, 0);
    return x <= cutoffGrenze();
  }
  /* Vertragsweite Aenderungen sind gesperrt, sobald die naechste Lieferung ansteht. */
  function aboGesperrt(c) {
    if (!cutoffTage() || !c) return false;
    var na = nextAttempt(c);
    return terminGesperrt(deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate));
  }
  /* --- Kuendigung im Bestellschluss-Fenster ----------------------------------
     Der Knopf „Abo kündigen“ ist immer da (§ 312k BGB). Steht die naechste Lieferung
     fest, wird die Kuendigung zum Liefertag vorgemerkt: zwei Vertragsattribute, eines
     lesbar fuer Packliste und Appstle-Admin, eines maschinenlesbar fuer Shopify Flow,
     das den Vertrag nach der Abbuchung kuendigt (docs/abo-kuendigung-vorgemerkt.md).
     Ist das Fenster offen, kuendigt das Portal sofort wie bisher. */
  var KUEND_KEY = '_rr_kuendigung';
  var KUEND_LABEL = 'Kündigung zum';
  function fmtDatum(d) { return d ? ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear() : ''; }
  function isoDatum(d) { return d ? d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) : ''; }
  /* Kuendigung muss vorgemerkt statt sofort ausgefuehrt werden? */
  function kuendigungSpaeter(c) { return cfg.cutoffLockCancel !== false && (c.status === 'ACTIVE' || c.status === 'FAILED') && aboGesperrt(c); }
  function vorgemerkt(c) { return !!(c && c.kuendigungZum && (c.status === 'ACTIVE' || c.status === 'FAILED')); }

  var PAUSE_MAX = 10;
  /* Termine, die beim Pausieren übersprungen werden können: die geplanten Bestellungen aus Appstle;
     kennt Appstle keine, werden sie aus nächstem Abrechnungstermin und Rhythmus hochgerechnet (id = null → skip-upcoming) */
  function pauseOptions(c) {
    if (c.attempts === null) return []; /* Termine laden noch – Dialog zeigt den Spinner */
    var real = queuedAttempts(c).filter(function (a) { return String(a.status).toUpperCase() !== 'SKIPPED'; })
      .map(function (a) { return { id: a.id, billing: parseDate(a.billingDate) }; })
      .filter(function (o) { return o.billing; }).slice(0, PAUSE_MAX);
    if (real.length) return real;
    if (!c.nextBillingDate) return [];
    var step = intervalDays(c.billingPolicy || c.deliveryPolicy), out = [];
    for (var i = 0; i < PAUSE_MAX; i++) out.push({ id: null, billing: addDays(c.nextBillingDate, i * step) });
    return out;
  }

  /* ---------- State ---------- */
  var state = { contracts: [], selectedId: null, dialog: null, dialogData: {}, toast: null, busy: false, error: null, needsLogin: false, boxProduct: null, lastError: null, debugRaw: {},
    /* [RR feat] Treuepunkte: Reiter und Stand (data = Kunden-Metafeld, spaeter frisch aus der API) */
    tab: 'abos', loy: { data: (cfg.loyalty && cfg.loyalty.customer) || null, geladen: false, laden: false, laeuft: null, fehler: null, fehlt: false, verlauf: null, referrals: null, codes: {} } };
  var toastTimer = null;

  function showToast(msg, variant) {
    clearTimeout(toastTimer);
    state.toast = { msg: msg, variant: variant || 'success' };
    renderToast();
    toastTimer = setTimeout(function () { state.toast = null; renderToast(); }, variant === 'error' ? 6000 : 3400);
  }
  function setBusy(b) { state.busy = b; app.classList.toggle('is-busy', b); }
  function selected() {
    return state.contracts.filter(function (c) { return c.id === state.selectedId; })[0] || null;
  }

  /* ---------- Laden ---------- */
  function byId(id) { return state.contracts.filter(function (c) { return c.id === id; })[0] || null; }
  function fetchContract(id, fb) {
    return Appstle.contract(id).then(function (raw) { return normalizeContract(raw, fb); }, function (err) {
      if (!fb || !fb.status) throw err;
      /* Appstle antwortet nicht – das Kunden-Metafeld reicht für eine Grundansicht */
      return normalizeContract({ id: id, status: fb.status, nextBillingDate: fb.nextBillingDate, lines: (fb.lineItems || []).map(function (li) { return { title: li.title, variantId: li.variantId, quantity: 1 }; }) }, fb);
    });
  }
  /* Termine und Rhythmen hängen nur an der Vertrags-ID – sie werden parallel zum Vertrag geholt, nicht erst danach */
  var prefetch = {};
  function startPrefetch(id) {
    if (!prefetch[id]) prefetch[id] = { attempts: fetchAttempts(id), freq: Appstle.frequencies(id).then(unwrap, function () { return []; }) };
  }
  function takePrefetch(id) { var p = prefetch[id]; delete prefetch[id]; return p; }
  function fetchFrequencies(c, pre) {
    /* Liefert Appstle keine Optionen, kommen die Verkaufspläne des gebuchten Box-Produkts aus dem Theme */
    var p = pre ? pre.freq : Appstle.frequencies(c.id).then(unwrap, function () { return []; });
    return p.then(function (list) { return list.length ? list : liquidFrequencies(c); });
  }
  var inflight = {};
  /* Termine, Historie und Rhythmen nachladen. Schreibt immer auf das aktuelle Objekt in state (Verträge werden beim
     Neuladen ersetzt) und gibt null zurück, wenn nichts zu laden ist – dann ist auch kein Neu-Rendern nötig. */
  function loadDetailData(c) {
    var needAttempts = !c.attempts || !c.history, needFreq = !c.frequencies;
    if (!needAttempts && !needFreq) return null;
    if (inflight[c.id]) return inflight[c.id];
    var jobs = [], pre = takePrefetch(c.id);
    if (needAttempts) jobs.push((pre ? pre.attempts : fetchAttempts(c.id)).then(function (r) { var x = byId(c.id); if (x) { x.attempts = r.attempts; x.history = r.history; x.fulfillments = r.fulfillments; } }));
    if (needFreq) jobs.push(fetchFrequencies(c, pre).then(function (f) { var x = byId(c.id); if (x) x.frequencies = f; }));
    var done = function () { delete inflight[c.id]; };
    inflight[c.id] = Promise.all(jobs).then(done, done);
    return inflight[c.id];
  }
  function loadAll() {
    var started = {};
    /* IDs aus dem Kunden-Metafeld sind sofort da – die Verträge dazu laden, während Appstle die gültigen IDs liefert */
    var start = function (n, fb) {
      started[n] = fetchContract(n, fb);
      if (Object.keys(started).length <= 3) startPrefetch(n); /* bei wenigen Abos Details sofort mitladen */
    };
    (cfg.metafieldSubscriptions || []).forEach(function (m) { var n = num(m && m.id); if (n && !started[n]) start(n, m); });
    return Appstle.validIds(cfg.customerId).then(function (res) {
      unwrap(res).forEach(function (v) { var n = num(v && (v.id || v)); if (n && !started[n]) start(n, null); });
    }, function () { /* Metafield reicht als Fallback */ }).then(function () {
      /* Ein einzelner fehlgeschlagener Vertrag darf die anderen nicht blockieren */
      return Promise.all(Object.keys(started).map(function (k) { return started[k].then(null, function (err) { return { failed: err }; }); }));
    }).then(function (results) {
      var contracts = results.filter(function (r) { return r && !r.failed; });
      var failed = results.filter(function (r) { return r && r.failed; });
      if (!contracts.length && failed.length) throw failed[0].failed;
      var order = { ACTIVE: 1, FAILED: 2, PAUSED: 3, CANCELLED: 4, EXPIRED: 5 };
      contracts.sort(function (a, b) { return (order[a.status] || 9) - (order[b.status] || 9) || (b.createdAt || 0) - (a.createdAt || 0); });
      state.contracts = contracts;
      state.error = null;
      /* Vorab geholte Details an die Verträge hängen (kein zusätzlicher Aufruf), Reste verwerfen */
      contracts.forEach(function (c) { if (prefetch[c.id]) loadDetailData(c); });
      Object.keys(prefetch).forEach(function (k) { delete prefetch[k]; });
    });
  }

  /* Vertrag neu laden: Vertrag und Termine parallel, Rhythmen bleiben (bei Theme-Plänen neu zugeordnet) */
  function reloadContract(id) {
    return Promise.all([Appstle.contract(id), fetchAttempts(id)]).then(function (r) {
      var fresh = normalizeContract(r[0]);
      fresh.attempts = r[1].attempts; fresh.history = r[1].history; fresh.fulfillments = r[1].fulfillments;
      state.contracts = state.contracts.map(function (c) {
        if (c.id !== id) return c;
        fresh.frequencies = (c.frequencies && c.frequencies[0] && c.frequencies[0].source === 'liquid') ? liquidFrequencies(fresh) : c.frequencies;
        return fresh;
      });
    });
  }
  /* --- Lieferstatus ---------------------------------------------------------
     Der Status eines Bestellversuchs sagt nur, ob die Abbuchung geklappt hat.
     Ob die Box unterwegs oder da ist, steht im Fulfillment der Bestellung.
     Appstle liefert es je nach Endpunkt unter verschiedenen Feldnamen, deshalb
     werden mehrere Schreibweisen geprueft. Ist nichts zu finden, bleibt der
     Status unbekannt und die Zeile behauptet keine Lieferung. */
  var ORDER_KEYS = ['orderId', 'orderID', 'order_id', 'shopifyOrderId', 'orderName', 'name', 'orderNumber'];
  /* Im verschachtelten order-Objekt heisst die Bestellung "id". Auf der obersten Ebene waere "id"
     dagegen die des Fulfillments und wuerde einen falschen Schluessel anlegen. */
  var ORDER_KEYS_NESTED = ['id'].concat(ORDER_KEYS);
  var FULFILL_KEYS = ['fulfillmentStatus', 'displayFulfillmentStatus', 'orderFulfillmentStatus', 'shipmentStatus', 'status', 'state'];

  /* Bestellung auf einen Schluessel bringen: "#1322" und gid://shopify/Order/1322 werden beide zu "1322". */
  function orderKey(v) {
    if (v == null || (typeof v !== 'string' && typeof v !== 'number')) return '';
    var t = String(v).trim();
    if (!t) return '';
    var m = t.match(/(\d+)\s*$/);
    return m ? m[1] : t.replace(/^#/, '').toUpperCase();
  }
  /* true = geliefert, false = noch nicht, null = unbekannt.
     UNFULFILLED enthaelt FULFILLED, deshalb zuerst auf die verneinenden Formen pruefen. */
  function fulfilledFlag(v) {
    var t = String(v == null ? '' : v).toUpperCase().replace(/[\s_-]/g, '');
    if (!t) return null;
    if (/UNFULFILLED|NOTFULFILLED|PARTIAL|PENDING|OPEN|SCHEDULED|INPROGRESS|ONHOLD|CANCEL|RESTOCK/.test(t)) return false;
    if (/FULFILLED|DELIVERED|COMPLETE/.test(t)) return true;
    return null;
  }
  /* Antwort des Fulfillment-Endpunkts auf { Bestellschluessel: true|false } bringen. */
  function fulfillmentMap(res) {
    var list = unwrap(res);
    if (!list.length && res && typeof res === 'object' && !Array.isArray(res)) list = [res];
    var map = {};
    list.forEach(function (e) {
      if (!e || typeof e !== 'object') return;
      var flag = null;
      FULFILL_KEYS.forEach(function (k) { if (flag === null) flag = fulfilledFlag(e[k]); });
      if (flag === null) return;
      var quellen = [[e, ORDER_KEYS]];
      if (e.order && typeof e.order === 'object') quellen.push([e.order, ORDER_KEYS_NESTED]);
      quellen.forEach(function (q) {
        q[1].forEach(function (k) {
          var key = orderKey(q[0][k]);
          if (key) map[key] = flag;
        });
      });
    });
    return map;
  }
  /* Lieferstatus einer Zeile: erst das, was am Bestellversuch selbst haengt, dann die Fulfillment-Liste. */
  function attemptFulfilled(c, h) {
    var eigen = fulfilledFlag(h.fulfillment);
    if (eigen !== null) return eigen;
    var map = c && c.fulfillments;
    if (!map) return null;
    var keys = [orderKey(h.orderId), orderKey(h.orderName)];
    for (var i = 0; i < keys.length; i += 1) {
      if (keys[i] && map[keys[i]] != null) return map[keys[i]];
    }
    return null;
  }

  /* Appstle-Bestellversuch auf die Felder bringen, die das Portal braucht (Doku: id, status, billingDate, orderName, orderAmount) */
  function normAttempt(a) {
    a = a || {};
    return {
      id: a.id != null ? a.id : (a.billingAttemptId || a.attemptId),
      status: String(a.status || a.billingAttemptStatus || a.attemptStatus || '').toUpperCase(),
      billingDate: a.billingDate || a.nextBillingDate || a.billingDateTime || a.date || null,
      attemptTime: a.attemptTime || null, orderName: a.orderName, orderAmount: a.orderAmount,
      orderId: a.orderId != null ? a.orderId : (a.orderID != null ? a.orderID : (a.shopifyOrderId != null ? a.shopifyOrderId : null)),
      /* Falls past-orders den Fulfillment-Status schon mitliefert, spart das den Zusatzaufruf. */
      fulfillment: a.fulfillmentStatus || a.orderFulfillmentStatus || a.displayFulfillmentStatus || null,
      raw: a
    };
  }
  function fetchAttempts(id) {
    var up = Appstle.upcoming(id).then(function (res) {
      if (DEBUG) state.debugRaw.topOrders = JSON.stringify(res).slice(0, 400);
      return unwrap(res).map(normAttempt);
    }, function (err) { state.debugRaw.topOrders = 'Fehler ' + (err && err.status) + ' ' + (err && err.message); return null; });
    var past = Appstle.past(id).then(function (res) {
      if (DEBUG) state.debugRaw.pastOrders = JSON.stringify(res).slice(0, 400);
      return unwrap(res).map(normAttempt);
    }, function (err) { state.debugRaw.pastOrders = 'Fehler ' + (err && err.status) + ' ' + (err && err.message); return null; });
    /* Scheitert der Fulfillment-Aufruf, bleibt die Karte leer und die Zeilen sagen
       "Bezahlt, Lieferung folgt". Eine Lieferung wird nie behauptet. */
    var ff = Appstle.fulfillments(id).then(function (res) {
      if (DEBUG) state.debugRaw.fulfillments = JSON.stringify(res).slice(0, 400);
      return fulfillmentMap(res);
    }, function (err) { state.debugRaw.fulfillments = 'Fehler ' + (err && err.status) + ' ' + (err && err.message); return {}; });
    return Promise.all([up, past, ff]).then(function (r) { return { attempts: r[0] || [], history: r[1] || [], fulfillments: r[2] || {} }; });
  }
  function cleanName(n) { return String(n || '').replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, ' ').trim(); }
  function liquidFrequencies(c) {
    var cur = c.box && boxVariants[c.box.variantId];
    var plans = (cur && cur.plans) || [];
    if (!plans.length) return [];
    var curPlan = num(c.box.sellingPlanId);
    /* Nur die Verkaufsplan-Gruppe anbieten, in der das Abo läuft; sonst die Appstle-Gruppe; sonst die erste */
    var group = null;
    plans.forEach(function (p) { if (curPlan && num(p.id) === curPlan) group = p.groupId; });
    if (!group) { var ap = plans.filter(function (p) { return /appstle/i.test(p.appId || ''); }); group = (ap[0] || plans[0]).groupId; }
    var list = plans.filter(function (p) { return p.groupId === group; });
    list.sort(function (a, b) { return (num(a.id) === curPlan ? 0 : 1) - (num(b.id) === curPlan ? 0 : 1); }); /* gebuchten Plan bei Duplikaten behalten */
    var curLabel = cleanName(rhythmLabel(c.billingPolicy || c.deliveryPolicy)).toLowerCase();
    var firstIdx = {};
    plans.forEach(function (p, i) { var k = cleanName(p.name).toLowerCase(); if (!(k in firstIdx)) firstIdx[k] = i; });
    var seen = {}, out = [];
    list.forEach(function (p) {
      var name = cleanName(p.name), key = name.toLowerCase();
      if (!name || seen[key]) return; seen[key] = p;
      /* aktiv = gebuchter Plan; kennt der Vertrag keine Plan-ID, zählt der passende Rhythmus-Name */
      var act = curPlan ? num(p.id) === curPlan : key === curLabel;
      out.push({ sellingPlanId: num(p.id), name: name, selected: act, source: 'liquid', order: firstIdx[key] });
    });
    out.sort(function (a, b) { return a.order - b.order; });
    return out;
  }

  /* ---------- Rendering: Bausteine ---------- */
  function badge(variant, text, extraClass) {
    return '<span class="rrp-badge rrp-badge--' + variant + (extraClass ? ' ' + extraClass : '') + '">' + esc(text) + '</span>';
  }
  function btn(variant, label, action, data, extraClass, gesperrt) {
    var attrs = '';
    Object.keys(data || {}).forEach(function (k) { attrs += ' data-' + k + '="' + esc(data[k]) + '"'; });
    if (gesperrt) attrs += ' disabled title="Diese Lieferung ist schon in Vorbereitung."';
    return '<button type="button" class="rrp-btn rrp-btn--' + variant + (extraClass ? ' ' + extraClass : '') + '" data-action="' + esc(action) + '"' + attrs + '>' + esc(label) + '</button>';
  }

  /* Retterränge (Design-Handoff): Schwelle in kg, Namen je Schreibweise, Lucide-Icons */
  var RANKS = [
    { kg: 0, names: { neutral: 'Frischling', weiblich: 'Frischling', maennlich: 'Frischling' }, icon: ['M7 20h10', 'M10 20c5.5-2.5.8-6.4 3-10', 'M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z', 'M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z'] },
    { kg: 10, names: { neutral: 'Feldhelfer:in', weiblich: 'Feldhelferin', maennlich: 'Feldhelfer' }, icon: ['M2 22v-5l5-5 5 5-5 5z', 'M9.5 14.5 16 8', 'm17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2'] },
    { kg: 25, names: { neutral: 'Ackerheld:in', weiblich: 'Ackerheldin', maennlich: 'Ackerheld' }, icon: ['M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15', 'M11 12 5.12 2.2', 'm13 12 5.88-9.8', 'M8 7h8', 'M12 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10z'] },
    { kg: 50, names: { neutral: 'Rübenretter:in', weiblich: 'Rübenretterin', maennlich: 'Rübenretter' }, icon: ['M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46', 'M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z', 'M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z'] },
    { kg: 100, names: { neutral: 'Ernte-Legende', weiblich: 'Ernte-Legende', maennlich: 'Ernte-Legende' }, icon: ['M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.735H5.81a1 1 0 0 1-.957-.735L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z', 'M5 21h14'] }
  ];
  function rankName(r) { return r.names[cfg.rankStyle] || r.names.neutral; }
  function rankIcon(r, cls) {
    return '<svg class="rrp-rank-icon' + (cls ? ' ' + cls : '') + '" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      r.icon.map(function (d) { return '<path d="' + d + '"/>'; }).join('') + '</svg>';
  }
  function kgFmt(k) { return Number(k).toFixed(1).replace('.', ','); }
  function rankVals(totalKg) {
    var idx = RANKS.reduce(function (a, r, i) { return totalKg >= r.kg ? i : a; }, 0);
    var cur = RANKS[idx], next = RANKS[idx + 1];
    return {
      cur: cur, next: next,
      nextLabel: next ? rankName(next) + ' (ab ' + next.kg + ' kg)' : 'Höchster Rang erreicht',
      remaining: next ? 'Noch ' + kgFmt(next.kg - totalKg) + ' kg' : '',
      /* Fortschritt = gerettete Kilo im Verhältnis zur Schwelle des nächsten Rangs (10 von 25 kg = 40 %) */
      pct: next ? Math.min(100, Math.max(2, Math.round(totalKg / next.kg * 100))) : 100
    };
  }

  /* Datenquelle der Statistik. Liquid stellt customer.orders auf einer normalen Seite nicht bereit, die Liste
     kommt dort leer an und die Karte blendete sich aus. Ersatzweise wird aus den tatsaechlich gelieferten
     Boxen der Appstle-Vertraege gerechnet. Ist am Produkt ein Gewicht hinterlegt, wird damit gerechnet,
     sonst mit dem Durchschnittsgewicht je Box aus den Section-Einstellungen. */
  function statsOrders() {
    if ((cfg.orders || []).length) return cfg.orders;
    var out = [];
    (state.contracts || []).forEach(function (c) {
      /* Nur Box-Positionen zaehlen. Extras sind Einmal-Zugaben und keine geretteten Boxen; wuerden sie
         mitzaehlen, stuende bei einer Box mit zwei Extras das Dreifache in der Statistik. Erkannt werden sie
         positiv an den bekannten Box-Varianten: das Kennzeichen isExtra stammt aus der Extras-Kollektion, die
         oft gar nicht gesetzt ist, und deckt je Produkt nur eine Variante ab. */
      var lines = c.lines || [];
      var boxLines = lines.filter(function (l) { return boxVariants[l.variantId]; });
      if (!boxLines.length) boxLines = lines.filter(function (l) { return l.sellingPlanId && !l.isExtra; });
      if (!boxLines.length) boxLines = lines.filter(function (l) { return !l.isExtra; });
      var qty = boxLines.reduce(function (n, l) { return n + (Number(l.quantity) || 0); }, 0) || 1;
      /* Am Produkt hinterlegtes Gewicht je Box, sonst faellt renderStats auf das Durchschnittsgewicht
         aus den Section-Einstellungen zurueck. */
      var grams = 0;
      boxLines.forEach(function (l) {
        var b = boxVariants[l.variantId];
        if (b && Number(b.grams) > 0) grams += Number(b.grams) * (Number(l.quantity) || 1);
      });
      pastAttempts(c).forEach(function (a) {
        if (String(a.status || '').toUpperCase() !== 'SUCCESS') return;
        var d = parseDate(a.billingDate || a.attemptTime);
        if (!d) return;
        out.push({ date: d, grams: grams, boxes: qty, cancelled: false });
      });
    });
    return out;
  }

  function renderStats() {
    if (!cfg.showStats) return '';
    var orders = statsOrders().filter(function (o) { return !o.cancelled; });
    var kg = 0, first = null, year = new Date().getFullYear(), byMonth = {};
    orders.forEach(function (o) {
      var d = parseDate(o.date); if (!d) return;
      var w = o.grams > 0 ? o.grams / 1000 : (o.boxes || 1) * Number(cfg.avgBoxKg || 5);
      kg += w;
      if (!first || d < first) first = d;
      if (d.getFullYear() === year) byMonth[d.getMonth()] = (byMonth[d.getMonth()] || 0) + w;
    });
    if (cfg.totalKgOverride != null && !isNaN(Number(cfg.totalKgOverride))) kg = Number(cfg.totalKgOverride);
    /* Die Karte bleibt auch bei null stehen: der Zaehler soll von Anfang an sichtbar sein. */
    var zero = !orders.length && !kg;
    /* Die Anzahl kommt aus denselben Positionen wie die Kilo. customer.orders_count waere die groessere,
       aber unpassende Zahl: sie zaehlt auch stornierte Bestellungen und Einmalkaeufe mit. */
    var count = orders.reduce(function (n, o) { return n + (Number(o.boxes) || 1); }, 0);
    var rank = rankVals(kg);
    var months = Object.keys(byMonth).map(Number).sort(function (a, b) { return a - b; });
    var max = months.reduce(function (m, k) { return Math.max(m, byMonth[k]); }, 0) || 1;
    var chart = '';
    if (months.length) {
      chart = '<div class="rrp-chart__title">Dein Rettungsjahr ' + year + '</div><div class="rrp-chart">' + months.map(function (m, i) {
        var h = Math.max(4, Math.round(byMonth[m] / max * 56));
        return '<div class="rrp-chart__col" title="' + esc(kgFmt(byMonth[m]) + ' kg gerettet') + '"><div class="rrp-chart__bar' + (i === months.length - 1 ? ' rrp-chart__bar--current' : '') + '" style="height:' + h + 'px"></div><div class="rrp-chart__label">' + MON_XS[m] + '</div></div>';
      }).join('') + '</div>';
    }
    var meals = Math.round(kg * Number(cfg.mealsPerKg || 1.3));
    var compare = [];
    if (meals > 0) compare.push('≈ ' + meals + ' Mahlzeiten');
    if (Number(cfg.statsFarms) > 0) compare.push(cfg.statsFarms + ' Höfe aus deiner Region');
    var since = first ? MONTHS[first.getMonth()] + ' ' + first.getFullYear() : null;
    var name = zero
      ? (cfg.customerFirstName ? 'Gleich geht es los, ' + cfg.customerFirstName + '.' : 'Gleich geht es los.')
      : (cfg.customerFirstName ? 'Stark, ' + cfg.customerFirstName + '.' : 'Stark.');
    var sub = zero
      ? 'Ab deiner ersten Lieferung zählen wir hier mit, was du vor der Tonne bewahrt hast.'
      : count > 0
        ? 'Das wäre sonst auf dem Acker geblieben – stattdessen: ' + count + (count === 1 ? ' Box' : ' Boxen') + ' voller Gemüse mit Charakter' + (since ? ', seit ' + since : '') + '.'
        /* Kilo aus dem hinterlegten Gesamtwert, aber keine gezaehlten Lieferungen: dann keine Boxen nennen. */
        : 'Das wäre sonst auf dem Acker geblieben – stattdessen Gemüse mit Charakter auf deinem Teller.';
    return '<div class="rrp-card rrp-card--inverse rrp-card--clip rrp-stats">' +
      '<img class="rrp-watermark" src="' + esc(cfg.signetCreme) + '" alt="">' +
      '<div class="rrp-stats__inner"><div class="rrp-stats__left">' +
      '<div><span class="rrp-badge rrp-badge--orange rrp-badge--icon">' + rankIcon(rank.cur) + 'Dein Rang: ' + esc(rankName(rank.cur)) + '</span>' +
      '<div class="rrp-stats__headline">' + esc(kgFmt(kg)) + ' kg gerettet.<br>' + esc(name) + '</div>' +
      '<p class="rrp-stats__sub">' + esc(sub) + '</p></div>' +
      '<div class="rrp-progress"><div class="rrp-progress__head"><span class="rrp-progress__next">' + (rank.next ? rankIcon(rank.next) : '') + 'Nächster Rang: ' + esc(rank.nextLabel) + '</span><span>' + esc(rank.remaining) + '</span></div>' +
      '<div class="rrp-progress__track"><div class="rrp-progress__fill" style="width:' + rank.pct + '%"></div></div></div>' +
      '</div>' +
      (chart || compare.length ? '<div class="rrp-stats__right">' + chart + (compare.length ? '<div class="rrp-stats__compare">' + esc(compare.join(' · ')) + '</div>' : '') + '</div>' : '') +
      '</div></div>';
  }

  function renderSeason() {
    var m = new Date().getMonth() + 1;
    var raw = (cfg.season || {})[m];
    if (!raw) return '';
    var split = function (v) { return String(v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
    var groups = [
      { title: 'Neu dabei', cls: 'neu', items: split(raw.neu) },
      { title: 'Mitten in der Saison', cls: 'saison', items: split(raw.saison) },
      { title: 'Bald vorbei', cls: 'bald', items: split(raw.bald) }
    ].filter(function (g) { return g.items.length; });
    if (!groups.length) return '';
    return '<div class="rrp-card rrp-card--tip rrp-season"><div class="rrp-season__head"><h2 class="rrp__h2 rrp__h2--sm">Gerade vom Feld.</h2><span class="rrp-badge rrp-badge--inverse">' + MONTHS[m - 1] + '</span></div>' +
      '<p class="rrp-small rrp-muted rrp-season__lead">Was davon in deiner Box landet, entscheidet der Acker.</p>' +
      '<div class="rrp-season__grid">' + groups.map(function (g) {
        return '<div class="rrp-season__group rrp-season__group--' + g.cls + '"><div class="rrp-season__label"><span class="rrp-season__dot"></span>' + esc(g.title) + '</div>' +
          '<div class="rrp-chips">' + g.items.map(function (v) { return '<span class="rrp-chip">' + esc(v) + '</span>'; }).join('') + '</div></div>';
      }).join('') + '</div></div>';
  }

  /* ---------- [RR feat] Treuepunkte: Menue, Karten, Seiten ---------- */
  function renderMenu(aktiv) {
    if (!loyOn()) return '';
    var d = state.loy.data;
    var item = function (key, label, extra) {
      var on = aktiv === key;
      return '<button type="button" class="rrp-menu__item' + (on ? ' is-active' : '') + '" data-action="tab" data-tab="' + key + '"' + (on ? ' aria-current="page"' : '') + '>' + esc(label) + (extra || '') + '</button>';
    };
    return '<nav class="rrp-menu" aria-label="Bereiche des Portals">' + item('abos', 'Meine Abos') +
      item('punkte', 'Treuepunkte', d ? '<span class="rrp-menu__count">' + esc(punkteFmt(d.availablePoints)) + '</span>' : '') +
      (LOY.referralEnabled ? item('werben', 'Werben') : '') + '</nav>';
  }
  /* Kompakte Zeile am Ende von „Meine Abos“: Stand, naechste Belohnung, Sprung zum Menuepunkt */
  function renderLoyStrip() {
    if (!loyOn()) return '';
    var d = state.loy.data;
    var kopf, sub, knopf = 'Ansehen', cta = false;
    if (!d) {
      if (!state.loy.fehlt) return '';
      kopf = 'Punkte sammeln?'; sub = 'Für jede Lieferung gibt es Punkte, und die tauschst du gegen Rabatt auf deine Box.'; knopf = 'Mitmachen'; cta = true;
    } else {
      var avail = Number(d.availablePoints || 0), n = loyNext(avail);
      kopf = punkteWort(avail);
      var fehlt = n.next ? 'Noch ' + punkteWort(Number(n.next.redeemPoints) - avail) + ' bis ' + ruleTitel(n.next) + '.' : '';
      sub = n.best ? ruleTitel(n.best) + ' für deine nächste Box bereit. ' + fehlt : (fehlt || 'Jede Lieferung bringt Punkte.');
      if (n.best) { knopf = 'Einlösen'; cta = true; }
    }
    return '<button type="button" class="rrp-card rrp-loy-strip rrp-actionable" data-action="tab" data-tab="punkte">' +
      '<span class="rrp-loy-strip__icon">' + ICON.star + '</span>' +
      '<span class="rrp-loy-strip__text"><strong>' + esc(kopf) + '</strong><span class="rrp-small rrp-muted">' + esc(sub.trim()) + '</span></span>' +
      '<span class="rrp-btn rrp-btn--' + (cta ? 'cta' : 'secondary') + ' rrp-btn--sm">' + knopf + '</span></button>';
  }
  function renderReferBanner(gross) {
    if (!loyOn() || !LOY.referralEnabled) return '';
    var d = state.loy.data;
    var t = loyReferralText();
    var satz = t.du
      ? 'Du bekommst ' + t.du + ', ' + t.wann + (t.sie ? ' – und sie bekommt ' + t.sie : '') + '.'
      : (t.sie ? 'Sie bekommt ' + t.sie + ', ' + t.wann + '.' : 'Teile deinen Link und hol Freunde mit aufs Feld.');
    var link = d && d.referralLink;
    var n = d ? Number(d.referredCompleted || 0) : 0;
    return '<div class="rrp-card rrp-card--tip rrp-refer' + (gross ? ' rrp-refer--gross' : '') + '" id="rrp-werben">' +
      '<div class="rrp-refer__head"><span class="rrp-refer__icon">' + ICON.friends + '</span><div><h2 class="rrp__h2 rrp__h2--sm">Freunde werben</h2><p class="rrp-small">' + esc(satz) + '</p></div></div>' +
      (link ? '<div class="rrp-refer__link"><input type="text" class="rrp-refer__input" value="' + esc(link) + '" readonly aria-label="Dein Werbe-Link">' + btn('primary', 'Kopieren', 'loy-copy', { code: link }, 'rrp-btn--sm') + '</div>' : '') +
      '<div class="rrp-refer__actions">' +
      (link ? btn('cta', 'Link teilen', 'loy-share', { url: link }) + btn('secondary', 'Per Mail einladen', 'loy-mail') : btn('cta', 'Mitmachen', 'tab', { tab: 'punkte' })) +
      (n > 0 ? '<span class="rrp-small rrp-strong rrp-refer__count">' + esc(n + (n === 1 ? ' Person geworben' : ' Personen geworben')) + '</span>' : '') +
      '</div></div>';
  }
  function renderLoyBeitritt() {
    var earn = loyEarn().map(earnZeile);
    return '<div class="rrp-card rrp-card--pad rrp-loy"><h2 class="rrp__h2 rrp__h2--sm">Punkte sammeln?</h2><p class="rrp-small rrp-muted">Für jede Lieferung gibt es Punkte, und die tauschst du gegen Rabatt auf deine Box.</p>' +
      (earn.length ? '<div class="rrp-loy-earnlist">' + earn.map(function (z) { return '<div class="rrp-row"><div class="rrp-row__label">' + esc(z.was) + '</div><div class="rrp-small rrp-strong">' + esc(z.wie) + '</div></div>'; }).join('') + '</div>' : '') +
      '<div class="rrp-actions">' + btn('cta', 'Kostenlos mitmachen', 'loy-join') + '</div></div>';
  }
  function renderLoyLadeOderFehler(text) {
    if (state.loy.laden) return '<div class="rrp-card rrp-card--pad rrp-loading"><span class="rrp-spinner" aria-hidden="true"></span><span>' + esc(text) + '</span></div>';
    if (state.loy.fehler) return '<div class="rrp-card rrp-card--pad rrp-error"><h2 class="rrp__h2 rrp__h2--sm">Da hakt gerade etwas.</h2><p class="rrp-small">Wir konnten deine Punkte nicht laden. Versuch es gleich noch einmal oder schreib uns.</p><code>' + esc(state.loy.fehler) + '</code><div class="rrp-actions">' + btn('primary', 'Noch einmal versuchen', 'loy-reload') + '</div></div>';
    return renderLoyBeitritt();
  }
  function renderReward(r) {
    var code = r.discountCode && r.rewardType !== 'STORE_CREDIT';
    var kannAnwenden = code && aktiveAbos().length > 0;
    /* Rueckmeldung direkt in der Karte: die Einblendung unten ist im Vorschau-Modus von der Shopify-Leiste verdeckt */
    var st = state.loy.codes[r.discountCode] || null;
    var dran = code ? codeAufAbo(r.discountCode) : null;
    if (dran && !(st && st.laeuft)) st = { ok: true, abo: boxTitle(dran) };
    var stHtml = '';
    if (st && st.laeuft) stHtml = '<p class="rrp-small rrp-strong rrp-loy-status"><span class="rrp-spinner" aria-hidden="true"></span>Wird auf dein Abo gelegt …</p>';
    else if (st && st.ok) stHtml = '<p class="rrp-small rrp-strong rrp-loy-status rrp-loy-status--ok">Liegt auf deinem Abo' + (st.abo ? ' „' + esc(st.abo) + '“' : '') + ' und wird bei der nächsten Abbuchung abgezogen.</p>';
    else if (st && st.fehler) stHtml = '<div class="rrp-small rrp-loy-status rrp-loy-status--fehler"><span>' + esc(st.fehler) + '</span>' + (st.roh ? '<details class="rrp-loy-status__details"><summary>Technische Details</summary><code>' + esc(st.roh) + '</code></details>' : '') + '</div>';
    return '<div class="rrp-loy-reward"><div class="rrp-loy-reward__head"><strong>' + esc(rewardTitel(r)) + '</strong>' + (rewardZeile(r) ? '<span class="rrp-xs rrp-muted">' + esc(rewardZeile(r)) + '</span>' : '') + '</div>' +
      (r.discountCode ? '<div class="rrp-loy-code"><code>' + esc(r.discountCode) + '</code>' + btn('ghost', 'Kopieren', 'loy-copy', { code: r.discountCode }, 'rrp-btn--sm') + '</div>' : '') +
      (code && !kannAnwenden ? '<p class="rrp-small rrp-muted">Du hast gerade kein laufendes Abo. Der Code gilt an der Kasse für deine nächste Abo-Bestellung.</p>' : '') +
      stHtml +
      '<div class="rrp-actions">' +
      (kannAnwenden && !(st && (st.ok || st.laeuft)) ? btn('primary', st && st.fehler ? 'Noch einmal versuchen' : 'Auf mein Abo anwenden', 'loy-apply', { code: r.discountCode }, 'rrp-btn--sm') : '') +
      (r.status === 'UNUSED' ? btn('ghost', 'Zurückgeben', 'loy-return', { reward: r.id }, 'rrp-btn--sm') : '') +
      '</div></div>';
  }
  function verlaufZeile(t) {
    var minus = t.pointType === 'DEBIT';
    var regel = loyRules().filter(function (r) { return Number(r.id) === Number(t.redeemRuleRuleId); })[0];
    var label = t.transactionRule === 'REDEEM_RULE' ? (regel ? ruleTitel(regel) + ' eingelöst' : 'Punkte eingelöst')
      : t.transactionRule === 'REFERRAL' ? 'Freund:in geworben'
      : t.transactionRule === 'REDEEM_REVERSAL' ? 'Belohnung zurückgegeben'
      : t.transactionRule === 'ADJUSTMENT' ? (t.note || 'Anpassung')
      : (function () {
        var er = loyEarn().filter(function (x) { return Number(x.id) === Number(t.earnRuleId); })[0];
        var was = er ? earnZeile(er).was : null;
        if (t.orderName) return (was && was !== 'Jede Lieferung' ? was : 'Lieferung') + ' ' + t.orderName;
        return was || t.note || 'Punkte gesammelt';
      })();
    var d = parseDate(t.createAt);
    var st = t.status === 'PENDING' ? badge('yellow', 'offen', 'rrp-badge--sm') : t.status === 'REJECTED' ? badge('orange', 'abgelehnt', 'rrp-badge--sm') : '';
    return '<div class="rrp-row"><div class="rrp-row__main"><div><div class="rrp-row__label">' + esc(label) + '</div>' + (d ? '<div class="rrp-xs rrp-muted">' + esc(fmtShort(d)) + '</div>' : '') + '</div>' + st + '</div>' +
      '<div class="rrp-row__side"><span class="rrp-loy-delta' + (minus ? ' rrp-loy-delta--minus' : '') + '">' + (minus ? '−' : '+') + esc(punkteFmt(Math.abs(Number(t.points || 0)))) + '</span></div></div>';
  }
  function renderLoyVerlauf() {
    var h = state.loy.verlauf;
    if (!h) return '';
    return '<div class="rrp-card rrp-loy-rules" id="rrp-verlauf"><div class="rrp-loy-rules__head"><h2 class="rrp__h2 rrp__h2--sm">Punkte-Verlauf</h2></div>' +
      (h.length ? h.map(verlaufZeile).join('') : '<div class="rrp-list__note">Noch nichts passiert. Deine erste Lieferung ändert das.</div>') + '</div>';
  }
  function renderPunkte() {
    var html = headerHtml('Hallo ' + (cfg.customerFirstName || 'du') + ' – deine Punkte, deine Belohnungen.') + renderMenu('punkte');
    var d = state.loy.data;
    if (!d) return html + renderLoyLadeOderFehler('Wir zählen deine Punkte …');
    var avail = Number(d.availablePoints || 0);
    var n = loyNext(avail);
    var voraus = loyVoraus();
    var offen = rewardsOffen(d);
    html += '<div class="rrp-card rrp-card--pad rrp-loy" id="rrp-punkte">' +
      '<div class="rrp-loy__head"><h2 class="rrp__h2 rrp__h2--sm">Deine Punkte</h2>' + (d.currentVipTier ? badge('yellow', 'Stufe ' + d.currentVipTier) : '') + '</div>' +
      '<div class="rrp-loy__num"><span class="rrp-loy__big">' + esc(punkteFmt(avail)) + '</span><span class="rrp-loy__unit">' + (Math.round(avail * 100) === 100 ? 'Punkt' : 'Punkte') + ' verfügbar</span></div>' +
      (Number(d.pendingPoints) > 0 ? '<p class="rrp-small rrp-muted">' + esc(punkteWort(d.pendingPoints)) + ' warten noch auf Freigabe.</p>' : '') +
      (voraus && voraus.punkte > 0 ? '<p class="rrp-small rrp-muted">≈ +' + esc(punkteWort(voraus.punkte)) + ' kommen mit deiner nächsten Lieferung' + (voraus.datum ? ' am ' + esc(fmtShort(voraus.datum)) : '.') + '</p>' : '') +
      (n.next
        ? '<div class="rrp-progress rrp-progress--hell"><div class="rrp-progress__head"><span>Noch ' + esc(punkteWort(Number(n.next.redeemPoints) - avail)) + ' bis ' + esc(ruleTitel(n.next)) + '</span><span>' + esc(punkteFmt(avail) + ' / ' + punkteFmt(n.next.redeemPoints)) + '</span></div><div class="rrp-progress__track"><div class="rrp-progress__fill" style="width:' + n.pct + '%"></div></div></div>'
        : (loyRules().length ? '<p class="rrp-small rrp-strong">Alle Belohnungen sind für dich freigeschaltet.</p>' : '')) +
      '</div>';
    html += renderReferBanner(false);
    if (offen.length) {
      html += '<div class="rrp-card rrp-card--pad rrp-loy-rewards"><h2 class="rrp__h2 rrp__h2--sm">Deine Belohnungen</h2><p class="rrp-small rrp-muted">Eingelöst und bereit. Leg den Code mit einem Tipp auf dein Abo, dann zieht Appstle ihn bei der nächsten Abbuchung ab.</p>' +
        offen.map(renderReward).join('') + '</div>';
    }
    var rules = loyRules();
    if (rules.length) {
      html += '<div class="rrp-card rrp-loy-rules" id="rrp-einloesen"><div class="rrp-loy-rules__head"><h2 class="rrp__h2 rrp__h2--sm">Jetzt einlösen</h2></div>' + rules.map(function (r) {
        var ok = Number(r.redeemPoints) <= avail;
        return '<div class="rrp-row rrp-loy-rule' + (ok ? '' : ' rrp-loy-rule--zu') + '"><div class="rrp-row__main"><div><div class="rrp-row__label">' + esc(ruleTitel(r)) + '</div><div class="rrp-xs rrp-muted">' + esc(ruleZeile(r)) + '</div></div></div>' +
          '<div class="rrp-row__side">' + (ok ? btn('cta', 'Einlösen', 'loy-redeem', { rule: r.id }, 'rrp-btn--sm') : '<span class="rrp-xs rrp-muted">Noch ' + esc(punkteWort(Number(r.redeemPoints) - avail)) + '</span>') + '</div></div>';
      }).join('') + '</div>';
    }
    var earn = loyEarn();
    var rt = loyReferralText();
    if (earn.length || (LOY.referralEnabled && rt.du)) {
      html += '<div class="rrp-card rrp-loy-rules"><div class="rrp-loy-rules__head"><h2 class="rrp__h2 rrp__h2--sm">So sammelst du</h2></div>' +
        earn.map(function (r) { var z = earnZeile(r); return '<div class="rrp-row"><div class="rrp-row__label">' + esc(z.was) + '</div><div class="rrp-small rrp-strong">' + esc(z.wie) + '</div></div>'; }).join('') +
        (LOY.referralEnabled && rt.du ? '<div class="rrp-row"><div class="rrp-row__label">Freund:in werben</div><div class="rrp-small rrp-strong">' + esc(rt.du + ' je Person') + '</div></div>' : '') + '</div>';
    }
    html += renderLoyVerlauf();
    return html;
  }
  function renderWerben() {
    var html = headerHtml('Hallo ' + (cfg.customerFirstName || 'du') + ' – hol Freunde mit aufs Feld.') + renderMenu('werben');
    var d = state.loy.data;
    if (!d) return html + renderLoyLadeOderFehler('Wir holen deinen Link …');
    html += renderReferBanner(true);
    var refs = state.loy.referrals;
    var n = Number(d.referredCompleted || 0);
    var ST = { PENDING: 'Noch kein Konto', CLAIMED: 'Geworben', RECURRING: 'Dabei' };
    html += '<div class="rrp-card rrp-loy-rules"><div class="rrp-loy-rules__head"><h2 class="rrp__h2 rrp__h2--sm">Deine Werbungen</h2>' + (n > 0 ? badge('green', n + ' geworben') : '') + '</div>' +
      (!refs ? '<div class="rrp-list__note">Wird geladen …</div>'
        : refs.length ? refs.map(function (r) {
          var dt = parseDate(r.createAt);
          return '<div class="rrp-row"><div class="rrp-row__main"><div><div class="rrp-row__label">' + esc(r.referredEmailId || 'Einladung') + '</div>' + (dt ? '<div class="rrp-xs rrp-muted">' + esc(fmtShort(dt)) + '</div>' : '') + '</div></div>' +
            '<div class="rrp-row__side">' + (r.referralRewarded ? '<span class="rrp-loy-delta">belohnt</span>' : '<span class="rrp-xs rrp-muted">' + esc(ST[r.status] || r.status || '') + '</span>') + '</div></div>';
        }).join('')
        : '<div class="rrp-list__note">Noch niemand geworben. Dein Link wartet oben.</div>') + '</div>';
    return html;
  }

  function renderOverview() {
    var cs = state.contracts;
    var html = headerHtml('Hallo ' + (cfg.customerFirstName || 'du') + ' – schön, dass du rettest.');
    html += renderMenu('abos');
    html += renderStats();
    if (!cs.length) {
      html += '<div class="rrp-card rrp-empty"><h2 class="rrp__h2 rrp__h2--sm">Noch kein Abo am Start.</h2><p class="rrp-small rrp-muted">Sobald du eine Box abonniert hast, verwaltest du hier Liefertermine und Extras.</p><div class="rrp-actions"><a class="rrp-btn rrp-btn--cta" href="' + esc(cfg.newSubscriptionUrl) + '">Box aussuchen</a></div></div>';
    } else {
      html += '<div class="rrp-subs">' + cs.map(function (c) {
        var b = statusBadge(c, true);
        var rhythm = rhythmLabel(c.billingPolicy || c.deliveryPolicy);
        var boxLine = [boxTitle(c) + (boxSize(c) ? ' (' + boxSize(c) + ')' : ''), rhythm, boxPrice(c) ? money(boxPrice(c)) : ''].filter(Boolean).join(' · ');
        var del = deliveryDate(c);
        var statusLine = vorgemerkt(c) ? 'Letzte Lieferung: ' + fmtShort(c.kuendigungZum) + ' · Kündigung vorgemerkt'
          : c.status === 'ACTIVE' ? 'Nächste Lieferung: ' + fmtShort(del) + (c.nextBillingDate ? ' · Abrechnung: ' + c.nextBillingDate.getDate() + '. ' + MON_S[c.nextBillingDate.getMonth()] : '')
          : c.status === 'PAUSED' ? 'Pausiert – du bestimmst, wann es weitergeht'
          : c.status === 'FAILED' ? 'Die letzte Abbuchung hat nicht geklappt – bitte Zahlart prüfen.'
          : 'Beendet – schön, dass du dabei warst.';
        var gek = c.status === 'CANCELLED' || c.status === 'EXPIRED';
        var bv = c.box && boxVariants[c.box.variantId];
        var img = bv && bv.image ? '<img class="rrp-sub__img" src="' + esc(bv.image) + '" alt="" width="88" height="88" loading="lazy" decoding="async">' : '';
        return '<div class="rrp-card rrp-sub rrp-actionable' + (img ? ' rrp-sub--img' : '') + '" data-action="open" data-id="' + c.id + '" role="button" tabindex="0">' + img +
          '<div class="rrp-sub__main"><div class="rrp-sub__title"><span class="rrp-sub__label">' + esc(boxTitle(c)) + '</span>' + badge(b[0], b[1]) + '</div>' +
          '<div class="rrp-small rrp-strong">' + esc(boxLine) + '</div>' +
          '<div class="rrp-small rrp-muted">' + esc(statusLine) + '</div>' +
          (addressLine(c) ? '<div class="rrp-xs rrp-muted">' + esc(addressLine(c)) + '</div>' : '') +
          '</div><div class="rrp-sub__actions">' +
          (gek ? btn('cta', 'Reaktivieren', 'reactivate', { id: c.id }, 'rrp-btn--sm') : '') +
          btn('secondary', 'Verwalten', 'open', { id: c.id }, 'rrp-btn--sm') +
          '</div></div>';
      }).join('') + '</div>';
      html += '<p class="rrp-more">Noch eine Adresse zu beliefern? <a href="' + esc(cfg.newSubscriptionUrl) + '">Weiteres Abo starten</a></p>';
    }
    html += renderSeason();
    /* Treue bewusst ganz unten und kompakt: das Abo bleibt die Hauptsache dieser Seite */
    html += renderLoyStrip();
    html += renderReferBanner(false);
    return html;
  }

  function renderDetail(c) {
    var b = statusBadge(c, false);
    var active = c.status === 'ACTIVE' || c.status === 'FAILED';
    /* Bestellschluss gilt nur fuer laufende Abos. Bei einem pausierten Vertrag steht
       keine Lieferung an, da darf nichts gesperrt sein. */
    var zu = active && aboGesperrt(c);
    var kuendZu = false; /* Kuendigen bleibt immer moeglich, im Fenster wird sie vorgemerkt */
    var vorg = vorgemerkt(c);
    var paused = c.status === 'PAUSED';
    var gek = c.status === 'CANCELLED' || c.status === 'EXPIRED';
    var del = deliveryDate(c);
    var html = '';
    html += '<button type="button" class="rrp-btn--link" data-action="back" style="margin-bottom:16px">' + ICON.back + '<span>Alle Abos</span></button>';
    /* Kopf bewusst knapp: Box-Name als Titel, Größe als Untertitel – Adresse und Rhythmus stehen in den Karten darunter */
    var hv = c.box && boxVariants[c.box.variantId];
    var himg = hv && hv.image ? '<img class="rrp__header-img" src="' + esc(hv.image) + '" alt="" width="64" height="64" loading="lazy" decoding="async">' : '';
    /* Status-Badge sitzt über dem Titel, bündig mit Titel und Größe – links daneben das Box-Bild */
    html += '<header class="rrp__header rrp__header--detail"><div class="rrp__header-main">' + himg + '<div class="rrp__header-text">' + badge(b[0], b[1], 'rrp-badge--sm') +
      '<h1 class="rrp__h1">' + esc(boxTitle(c)) + '</h1>' + (boxSize(c) ? '<p class="rrp__lead">' + esc(boxSize(c)) + '</p>' : '') + '</div></div></header>';
    /* Mit nur einem Abo landet die Kundin direkt hier, deshalb steht das Menue auch im Abo-Detail */
    html += renderMenu('abos');
    html += '<nav class="rrp-nav">' +
      (active ? '<a href="#rrp-naechste">Nächste Lieferung</a>' + (cfg.extras.length ? '<a href="#rrp-extras">Extras</a>' : '') + '<a href="#rrp-abo">Abo verwalten</a>' : '') +
      '<a href="#rrp-adresse">Adresse &amp; Zahlung</a><a href="#rrp-historie">Bisherige Bestellungen</a></nav>';

    if (paused) {
      html += '<div class="rrp-card rrp-card--tip rrp-banner rrp-actionable"><div><h2 class="rrp__h2 rrp__h2--sm">Dieses Abo ist pausiert.</h2><p class="rrp-small">Keine Lieferungen und keine Abbuchungen, bis du es hier wieder startest. Die nächste Box kommt dann zum nächsten regulären Termin.</p></div>' +
        '<div class="rrp-banner__actions">' + btn('cta', 'Jetzt fortsetzen', 'resume', { id: c.id }) + btn('ghost', 'Abo kündigen', 'open-cancel', { id: c.id }) + '</div></div>';
    }
    if (gek) {
      html += '<div class="rrp-card rrp-card--inverse rrp-banner rrp-actionable"><div><h2 class="rrp__h2 rrp__h2--sm">Dieses Abo ist gekündigt.</h2><p class="rrp-small">Das Gemüse vermisst dich jetzt schon.</p></div>' +
        btn('cta', 'Abo reaktivieren', 'reactivate', { id: c.id }) + '</div>';
    }
    if (vorg) {
      var kz = c.kuendigungZum, heute0 = new Date(); heute0.setHours(0, 0, 0, 0);
      var vorbei = kz < heute0;
      html += '<div class="rrp-card rrp-card--tip rrp-banner rrp-actionable"><div><h2 class="rrp__h2 rrp__h2--sm">Kündigung vorgemerkt.</h2><p class="rrp-small">' +
        (vorbei ? 'Deine letzte Box war die Lieferung am <strong>' + esc(fmtLong(kz)) + '</strong>. Wir schließen die Kündigung gerade ab; läuft dein Abo hier noch, kannst du es jetzt selbst endgültig beenden.'
          : 'Deine Lieferung am <strong>' + esc(fmtLong(kz)) + '</strong> ist fest und kommt noch. Danach endet dein Abo, es wird nichts mehr abgebucht.') + '</p></div>' +
        '<div class="rrp-banner__actions">' + (vorbei && !aboGesperrt(c) ? btn('secondary', 'Jetzt endgültig beenden', 'open-cancel2', { id: c.id }) : '') + btn('ghost', 'Kündigung zurücknehmen', 'cancel-withdraw', { id: c.id }) + '</div></div>';
    }
    if (c.status === 'FAILED') {
      html += '<div class="rrp-card rrp-card--tip rrp-banner rrp-actionable"><div><h2 class="rrp__h2 rrp__h2--sm">Die Abbuchung hat nicht geklappt.</h2><p class="rrp-small">Prüfe deine Zahlart, dann läuft die nächste Lieferung wieder wie gewohnt.</p></div>' +
        btn('cta', 'Zahlart ändern', 'payment', { id: c.id }) + '</div>';
    }

    if (active) {
      var na = nextAttempt(c);
      var nextBilling = na ? parseDate(na.billingDate) : c.nextBillingDate;
      var nextDel = deliveryDate(c, nextBilling);
      var extrasCount = c.extras.reduce(function (t, l) { return t + l.quantity; }, 0);
      var extrasTotal = c.extras.reduce(function (t, l) { return t + l.lineTotal; }, 0);
      html += '<section id="rrp-naechste" class="rrp-section"><h2 class="rrp__h2">Nächste Lieferung</h2>' +
        '<div class="rrp-card rrp-card--clip rrp-next rrp-actionable"><img class="rrp-watermark" src="' + esc(cfg.signetGruen) + '" alt="">' +
        '<div class="rrp-next__info"><div class="rrp-next__date">' + esc(fmtLong(nextDel)) + '</div>' +
        (nextBilling ? '<div class="rrp-xs rrp-muted">Nächste Abrechnung: ' + esc(fmtLong(nextBilling)) + '</div>' : '') +
        '<div class="rrp-badges">' + (rhythmLabel(c.billingPolicy || c.deliveryPolicy) ? badge('yellow', rhythmLabel(c.billingPolicy || c.deliveryPolicy)) : '') + (c.deliveryDay ? badge('yellow', c.deliveryDay) : '') + '</div>' +
        (addressLine(c) ? '<div class="rrp-meta">' + ICON.pin + '<span>' + esc(addressLine(c)) + '</span></div>' : '') +
        (cfg.extras.length ? '<div class="rrp-meta">' + ICON.box + '<span>' + esc(extrasCount ? extrasCount + ' Extra' + (extrasCount > 1 ? 's' : '') + ' dabei (' + money(extrasTotal) + ')' : 'Noch keine Extras dabei') + '</span></div>' : '') +
        '<div class="rrp-meta">' + ICON.box + '<span>' + esc(lieferSumme(c)) + '</span></div>' +
        '</div><div class="rrp-next__actions">' + btn('secondary', 'Diese Lieferung überspringen', 'skip-next', { id: c.id }, '', zu) +
        (cfg.extras.length && !zu ? '<a class="rrp-btn rrp-btn--cta" href="#rrp-extras">Extras hinzufügen</a>' : '') + '</div></div>';
      if (zu) {
        html += '<div class="rrp-card rrp-card--tip rrp-banner rrp-banner--sm"><div><p class="rrp-small rrp-strong">Diese Box ist schon in Vorbereitung.</p>' +
          '<p class="rrp-xs rrp-muted">Ab ' + cutoffTage() + ' Tagen vor der Lieferung steht der Inhalt fest. Änderungen an Box, Rhythmus und Extras wirken ab der Lieferung danach. Lieferadresse und Zahlart kannst du weiterhin ändern.</p></div></div>';
      }

      var qa = queuedAttempts(c);
      var skipped = qa.filter(function (a) { return String(a.status).toUpperCase() === 'SKIPPED'; });
      html += '<h3 class="rrp__h3">Die nächsten Wochen</h3>';
      if (skipped.length) {
        var lastSkip = deliveryDate(c, parseDate(skipped[skipped.length - 1].billingDate));
        html += '<div class="rrp-card rrp-card--tip rrp-banner rrp-banner--sm rrp-actionable"><div><p class="rrp-small rrp-strong">' +
          esc(skipped.length === 1 ? 'Du setzt eine Lieferung aus (' + fmtShort(lastSkip) + ')' : 'Du setzt ' + skipped.length + ' Lieferungen aus (bis ' + fmtShort(lastSkip) + ')') +
          '</p><p class="rrp-xs rrp-muted">Nächste Box: ' + esc(fmtShort(nextDel)) + ' – einzelne Wochen kannst du unten wieder aktivieren.</p></div>' +
          btn('secondary', skipped.length === 1 ? 'Wieder liefern' : 'Pause beenden – alle wieder liefern', 'unskip-all', { id: c.id }, 'rrp-btn--sm', zu) + '</div>';
      }
      html += '<div class="rrp-card rrp-card--md rrp-list rrp-actionable">';
      if (c.attempts === null) {
        html += '<div class="rrp-row"><div class="rrp-loading"><span class="rrp-spinner"></span><span>Termine laden …</span></div></div>';
      } else if (!qa.length) {
        html += '<div class="rrp-row"><span class="rrp-small rrp-muted">Noch keine geplanten Termine hinterlegt.</span></div>';
      } else {
        html += qa.slice(0, PAUSE_MAX).map(function (a) {
          var sk = String(a.status).toUpperCase() === 'SKIPPED';
          var d = deliveryDate(c, parseDate(a.billingDate));
          /* Nur die Termine im Bestellschluss sperren. Spaetere Wochen bleiben frei,
             sonst waere die ganze Liste tot, sobald die naechste Box ansteht. */
          var rowZu = terminGesperrt(d);
          return '<div class="rrp-row"><div class="rrp-row__main">' + ICON.cal + '<span class="rrp-row__label' + (sk ? ' is-skipped' : '') + '">' + esc(fmtShort(d)) + '</span>' + (sk ? badge('orange', 'Übersprungen', 'rrp-badge--sm') : '') + '</div>' +
            (rowZu ? badge('yellow', 'In Vorbereitung', 'rrp-badge--sm')
                   : btn('ghost', sk ? 'Wieder liefern' : 'Überspringen', sk ? 'unskip' : 'skip', { id: c.id, attempt: a.id }, 'rrp-btn--sm')) + '</div>';
        }).join('');
      }
      html += '<p class="rrp-list__note">Übersprungene Wochen werden nicht berechnet. Umbuchen geht bis ' + (cutoffTage() ? cutoffTage() + ' Tage vor der Lieferung – danach ist die Box in Vorbereitung' : 'zur Abrechnung') + '.</p></div></section>';

      if (cfg.extras.length) {
        /* [RR fix] Der Vorspann sagte "Direkt von unseren Höfen". Das stimmt für
           Extras nicht durchgehend: ein Teil ist zugekauft und nicht gerettet.
           Die Herkunftsaussage ist deshalb raus, dafuer steht dort jetzt, was
           die Extras wirklich sind. Der gelbe Hinweis zur naechsten Lieferung
           bleibt unveraendert. */
        html += '<section id="rrp-extras" class="rrp-section"><div class="rrp-section__head"><h2 class="rrp__h2">Extras für deine Box</h2>' + badge('yellow', 'Gilt nur für die nächste Lieferung') + '</div>' +
          '<p class="rrp-section__lead">Nicht jedes Extra ist gerettet – manches ist einfach etwas Besonderes, anderes praktisch für deinen Alltag. Alles wandert mit in deine Box.</p><div class="rrp-extras rrp-actionable" id="rrp-extras-row">';
        html += cfg.extras.map(function (p) {
          var line = c.extras.filter(function (l) { return l.variantId === p.id; })[0];
          var q = line ? line.quantity : 0;
          return '<div class="rrp-card rrp-extra"><div class="rrp-extra__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : 'Foto folgt') + '</div>' +
            '<div><div class="rrp-extra__name">' + esc(p.name) + '</div>' + (p.detail ? '<div class="rrp-small rrp-muted">' + esc(p.detail) + '</div>' : '') + '</div>' +
            '<div class="rrp-extra__foot"><span class="rrp-strong">' + esc(money(p.price)) + '</span>' +
            (q > 0 ? '<div class="rrp-qty"><button type="button" class="rrp-qty__btn rrp-qty__btn--minus" data-action="extra-dec" data-id="' + c.id + '" data-variant="' + p.id + '" aria-label="Weniger"' + (zu ? ' disabled' : '') + '>−</button><span class="rrp-qty__num">' + q + '</span><button type="button" class="rrp-qty__btn rrp-qty__btn--plus" data-action="extra-inc" data-id="' + c.id + '" data-variant="' + p.id + '" aria-label="Mehr"' + (zu ? ' disabled' : '') + '>+</button></div>'
              : (p.available === false ? badge('orange', 'Ausverkauft', 'rrp-badge--sm') : btn('primary', 'Hinzufügen', 'extra-inc', { id: c.id, variant: p.id }, 'rrp-btn--sm', zu))) +
            '</div></div>';
        }).join('') + '</div>';
        /* [RR feat] Pfeiltasten unter der Reihe. Am Telefon liegen die Extras in
           einer wischbaren Reihe; ohne Tasten ist nicht zu sehen, dass rechts
           noch etwas kommt. Nur dort sichtbar, am Schreibtisch steht das Raster. */
        html += '<div class="rrp-extras__nav" data-rrp-extras-nav>'
          + '<button type="button" class="rrp-extras__arrow" data-action="extras-prev" aria-label="Vorherige Extras" aria-controls="rrp-extras-row">' + ICON.arrowL + '</button>'
          + '<button type="button" class="rrp-extras__arrow" data-action="extras-next" aria-label="Weitere Extras" aria-controls="rrp-extras-row">' + ICON.arrowR + '</button>'
          + '</div>';
        if (extrasCount) html += '<div class="rrp-extras__summary">' + esc(extrasCount + ' Extra' + (extrasCount > 1 ? 's' : '') + ' · ' + money(extrasTotal) + ' – kommt zu deiner Lieferung am ' + fmtShort(nextDel) + ' dazu.') + '</div>';
        html += '</section>';
      }

      html += '<section id="rrp-abo" class="rrp-section"><h2 class="rrp__h2">Abo verwalten</h2><div class="rrp-card rrp-manage rrp-actionable">';
      var boxOpts = (cfg.boxes || []).filter(function (x) { return x.available !== false || (c.box && x.id === c.box.variantId); });
      if (boxOpts.length > 1 && c.box) {
        /* Stufe 1: ein Kärtchen je Hauptprodukt – Stufe 2: die Größen des aufgeklappten Produkts */
        var cur = boxVariants[c.box.variantId];
        var groups = [], byProd = {};
        boxOpts.forEach(function (x) {
          if (!byProd[x.productId]) { byProd[x.productId] = { productId: x.productId, product: x.product, image: null, variants: [] }; groups.push(byProd[x.productId]); }
          if (!byProd[x.productId].image && x.image) byProd[x.productId].image = x.image;
          byProd[x.productId].variants.push(x);
        });
        groups.forEach(function (g) { g.variants.sort(function (a, b) { return a.price - b.price; }); });
        var curPid = cur ? cur.productId : null;
        /* Die gebuchte Box steht immer vorn, danach aufsteigend nach dem günstigsten Preis des Produkts */
        var minPrice = function (g) { return Math.min.apply(null, g.variants.map(function (v) { return v.price; })); };
        groups.sort(function (a, b) {
          var ac = a.productId === curPid ? 0 : 1, bc = b.productId === curPid ? 0 : 1;
          return ac !== bc ? ac - bc : minPrice(a) - minPrice(b);
        });
        var openPid = (state.boxProduct && byProd[state.boxProduct]) ? state.boxProduct : (curPid && byProd[curPid] ? curPid : groups[0].productId);
        html += '<div><div class="rrp-manage__title">Deine Box</div><p class="rrp-small rrp-muted rrp-boxes__hint">Tippe auf eine Box, um die Größen zu sehen.</p><div class="rrp-boxes">' + groups.map(function (g) {
          var isCur = g.productId === curPid, isOpen = g.productId === openPid;
          var prices = g.variants.map(function (v) { return v.price; });
          var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
          var sub = g.variants.length > 1 ? g.variants.length + ' Größen · ' + (min === max ? money(min) : 'ab ' + money(min)) : (g.variants[0].variant ? g.variants[0].variant + ' · ' : '') + money(min);
          return '<button type="button" class="rrp-box' + (g.image ? ' rrp-box--img' : '') + (isOpen ? ' is-active' : '') + (isCur ? ' is-current' : '') + '" data-action="pick-product" data-id="' + c.id + '" data-product="' + g.productId + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '">' +
            (g.image ? '<img class="rrp-box__img" src="' + esc(g.image) + '" alt="" width="72" height="72" loading="lazy" decoding="async">' : '') +
            '<span class="rrp-box__body"><span class="rrp-box__name">' + esc(g.product) + '</span>' +
            (isCur ? '<span class="rrp-box__desc">Deine aktuelle Box' + (cur && cur.variant ? ' · ' + esc(cur.variant) : '') + '</span>' : '') +
            '<span class="rrp-box__price">' + esc(sub) + '</span></span></button>';
        }).join('') + '</div>';
        var og = byProd[openPid];
        if (og) {
          html += '<div class="rrp-sizes"><div class="rrp-sizes__title">' + esc(og.product) + ': Größe wählen</div><div class="rrp-sizes__list">' + og.variants.map(function (x) {
            var act = c.box.variantId === x.id;
            return '<button type="button" class="rrp-size' + (act ? ' is-active' : '') + '" data-action="pick-box" data-id="' + c.id + '" data-variant="' + x.id + '"' + (act ? ' aria-pressed="true"' : '') + ((zu && !act) ? ' disabled' : '') + '>' +
              '<span class="rrp-size__name">' + esc(x.variant || 'Standard') + '</span>' +
              '<span class="rrp-size__price">' + esc(money(x.price)) + ' / Box</span>' +
              (act ? '<span class="rrp-size__tag">Aktuell</span>' : '') + '</button>';
          }).join('') + '</div></div>';
        }
        html += '</div>';
      }
      var freqs = c.frequencies || [];
      html += '<div><div class="rrp-manage__title">Lieferrhythmus</div>';
      if (c.frequencies === null) {
        html += '<div class="rrp-small rrp-muted">Optionen laden …</div>';
      } else if (freqs.length) {
        html += '<div class="rrp-pills">' + freqs.map(function (f, i) {
          var label = freqLabel(f);
          var act = istAktiverRhythmus(c, f);
          return '<button type="button" class="rrp-pill' + (act ? ' is-active' : '') + '" data-action="pick-frequency" data-id="' + c.id + '" data-index="' + i + '"' + ((zu && !act) ? ' disabled' : '') + '>' + esc(label) + '</button>';
        }).join('') + '</div>';
      } else {
        html += '<div class="rrp-pills"><span class="rrp-pill is-active">' + esc(rhythmLabel(c.billingPolicy || c.deliveryPolicy) || 'Wie gebucht') + '</span></div><p class="rrp-xs rrp-muted" style="margin-top:8px">Für diese Box ist aktuell nur ein Rhythmus verfügbar.</p>';
      }
      html += '</div>' + (zu ? '<p class="rrp-xs rrp-muted rrp-manage__hint">Deine nächste Box ist in Vorbereitung. Änderungen hier wirken ab der Lieferung danach. Du möchtest an dieser Lieferung noch etwas ändern? Schreib uns an <a href="mailto:' + esc(shopMail()) + '">' + esc(shopMail()) + '</a>.</p>' : '') +
        '<div class="rrp-manage__foot">' + btn('secondary', 'Lieferungen aussetzen', 'open-pause', { id: c.id }, '', zu) +
        (vorg ? btn('ghost', 'Kündigung zurücknehmen', 'cancel-withdraw', { id: c.id }) : btn('ghost', 'Abo kündigen', 'open-cancel', { id: c.id }, '', kuendZu)) + '</div></div></section>';
    }

    var a = c.address;
    var name = [a.firstName, a.lastName].filter(Boolean).join(' ') || a.company;
    html += '<section id="rrp-adresse" class="rrp-section"><h2 class="rrp__h2">Adresse &amp; Zahlung</h2><div class="rrp-grid2 rrp-actionable">' +
      '<div class="rrp-card rrp-info"><div class="rrp-info__title">' + ICON.pinMd + '<span>Lieferadresse</span></div>' +
      '<div class="rrp-info__body">' + (name ? esc(name) + '<br>' : '') + (a.company && name !== a.company ? esc(a.company) + '<br>' : '') + esc(a.address1) + (a.address2 ? ', ' + esc(a.address2) : '') + '<br>' + esc([a.zip, a.city].filter(Boolean).join(' ')) + '</div>' +
      (c.note ? '<div class="rrp-xs rrp-muted">Hinweis für die Zustellung: ' + esc(c.note) + '</div>' : '') +
      (gek ? '' : '<div>' + btn('secondary', 'Bearbeiten', 'open-address', { id: c.id }, 'rrp-btn--sm') + '</div>') + '</div>' +
      '<div class="rrp-card rrp-info"><div class="rrp-info__title">' + ICON.card + '<span>Zahlart</span></div>' +
      '<div class="rrp-info__body">' + (c.payment ? esc(c.payment.brand ? c.payment.brand.charAt(0).toUpperCase() + c.payment.brand.slice(1).toLowerCase() : 'Karte') + (c.payment.last4 ? ' •••• ' + esc(c.payment.last4) : '') + (c.payment.month ? '<br>Gültig bis ' + esc(('0' + c.payment.month).slice(-2) + '/' + String(c.payment.year).slice(-2)) : '') : 'Hinterlegte Zahlart') + '</div>' +
      '<div class="rrp-xs rrp-muted">Abgerechnet wird ' + (cfg.deliveryOffsetDays ? cfg.deliveryOffsetDays + ' Tage vor jeder Lieferung' : 'am Liefertag') + '.</div>' +
      (gek ? '' : '<div>' + btn('secondary', 'Zahlart ändern', 'payment', { id: c.id }, 'rrp-btn--sm') + '</div>') + '</div></div></section>';

    html += '<section id="rrp-historie" class="rrp-section"><h2 class="rrp__h2">Bisherige Bestellungen</h2><div class="rrp-card rrp-card--md rrp-list">';
    if (c.history === null) {
      html += '<div class="rrp-row"><div class="rrp-loading"><span class="rrp-spinner"></span><span>Bestellungen laden …</span></div></div>';
    } else if (!pastAttempts(c).length) {
      html += '<div class="rrp-row"><span class="rrp-small rrp-muted">Noch keine Bestellung – die erste kommt bald.</span></div>';
    } else {
      html += pastAttempts(c).slice(0, 12).map(function (h) {
        var s = String(h.status || '').toUpperCase();
        /* SUCCESS meldet Appstle fuer den Zahlungsversuch, nicht fuer die Zustellung. Appstle weiss
           vom Liefern nichts. "Geliefert" stand hier also an einem Tag, an dem die Box noch gar nicht
           unterwegs war. Der Abrechnungstag liegt cfg.deliveryOffsetDays Tage vor der Lieferung. */
        var geliefert = s === 'SUCCESS' ? attemptFulfilled(c, h) : null;
        var map = s === 'SKIPPED' ? ['orange', 'Übersprungen']
          : (s === 'FAILURE' || s === 'FAILED') ? ['orange', 'Zahlung fehlgeschlagen']
          : s === 'SUCCESS' ? (geliefert === true ? ['green', 'Geliefert'] : ['yellow', 'Bezahlt, Lieferung folgt'])
          : ['yellow', 'Geplant'];
        /* Abrechnungstag, nicht Liefertag. Abrechnung plus Offset trifft nur die Folgebestellungen;
           bei der ersten waehlt der Kunde seinen Liefertag frei, da lagen bis zu sieben Tage dazwischen. */
        var d = parseDate(h.billingDate || h.attemptTime);
        var detail = s === 'SKIPPED' ? 'Übersprungen' : boxTitle(c) + (h.orderName ? ' · Bestellung ' + h.orderName : '');
        /* 0,00 EUR meldet Appstle auch fuer Bestellungen, die es nicht selbst angelegt hat,
           etwa die erste aus dem Shop. Lieber kein Betrag als eine falsche Null. */
        var total = s === 'SKIPPED' ? money(0) : (Number(h.orderAmount) > 0 ? money(h.orderAmount) : '');
        return '<div class="rrp-row"><div><div class="rrp-row__label">' + esc(fmtShort(d)) + '</div><div class="rrp-small rrp-muted">' + esc(detail) + '</div></div>' +
          '<div class="rrp-row__side">' + (total ? '<span class="rrp-strong rrp-small">' + esc(total) + '</span>' : '') + badge(map[0], map[1], 'rrp-badge--sm') + '</div></div>';
      }).join('');
    }
    html += '<p class="rrp-list__note">Belege bekommst du nach jeder Abbuchung per E-Mail.</p></div></section>';
    return html;
  }

  function renderDialog() {
    var host = document.getElementById('rrp-dialog-host');
    if (!host) { host = document.createElement('div'); host.id = 'rrp-dialog-host'; host.className = 'rrp rrp--overlay'; document.body.appendChild(host); }
    var c = selected();
    var loyDialog = /^loy-/.test(String(state.dialog || ''));
    if (!state.dialog || (!c && !loyDialog)) { host.innerHTML = ''; document.body.style.overflow = ''; return; }
    var d = state.dialogData;
    var inner = '', title = '';
    var na = c ? nextAttempt(c) : null;
    var nextDel = c ? deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate) : null;
    if (state.dialog === 'pause') {
      /* [RR] Kein Pausieren ohne Enddatum mehr: der Dialog setzt nur einzelne
         Liefertermine aus, das Abo bleibt aktiv. */
      title = 'Lieferungen aussetzen';
      var opts = pauseOptions(c);
      var count = Math.min(Math.max(1, d.count || 2), opts.length || 1);
      if (c.attempts === null && !opts.length) {
        inner = '<div class="rrp-loading"><span class="rrp-spinner"></span><span>Termine laden …</span></div>';
      } else if (!opts.length) {
        inner = '<p>Wir finden gerade keine geplanten Termine. Versuch es gleich noch einmal oder schreib uns.</p><div class="rrp-dialog__foot">' + btn('ghost', 'Schließen', 'close-dialog') + '</div>';
      } else {
        var after = opts[count] ? deliveryDate(c, opts[count].billing) : null;
        inner = '<p>Tippe auf die letzte Lieferung, die wir aussetzen sollen. Danach geht dein Abo automatisch weiter.</p>' +
          '<div class="rrp-pause-list">' + opts.map(function (o, i) {
            var sel = i < count;
            return '<button type="button" class="rrp-pause-row' + (sel ? ' is-selected' : '') + '" data-action="pause-count" data-count="' + (i + 1) + '" aria-pressed="' + (sel ? 'true' : 'false') + '">' +
              '<span class="rrp-pause-row__idx">' + (i + 1) + '</span><span class="rrp-pause-row__date">' + esc(fmtShort(deliveryDate(c, o.billing))) + '</span>' +
              '<span class="rrp-pause-row__tag">' + (sel ? 'aussetzen' : '') + '</span></button>';
          }).join('') + '</div>' +
          '<p class="rrp-small rrp-pause-summary">' + (after ? 'Nächste Box dann am <strong>' + esc(fmtLong(after)) + '</strong>.' : 'Nächste Box: der erste Termin nach der Pause.') + ' Einzelne Wochen kannst du unter „Die nächsten Wochen“ jederzeit wieder aktivieren.</p>' +
          '<div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', count === 1 ? '1 Lieferung aussetzen' : count + ' Lieferungen aussetzen', 'confirm-pause', { id: c.id, count: count }) + '</div>';
      }
    } else if (state.dialog === 'swap') {
      var nv = boxVariants[Number(d.variant)] || {};
      title = 'Box wechseln';
      inner = '<p>Ab deiner nächsten Lieferung' + (nextDel ? ' am <strong>' + esc(fmtLong(nextDel)) + '</strong>' : '') + ' bekommst du <strong>' + esc(nv.product + (nv.variant ? ' (' + nv.variant + ')' : '')) + '</strong> für ' + esc(money(nv.price)) + ' pro Lieferung.</p>' +
        '<div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', 'Ja, wechseln', 'confirm-swap', { id: c.id, variant: nv.id }) + '</div>';
    } else if (state.dialog === 'cancel1') {
      title = 'Bevor du gehst …';
      var smaller = smallerBox(c);
      /* Halte-Angebote, die der Bestellschluss ohnehin blockiert, gar nicht erst anbieten. */
      var haltZu = aboGesperrt(c);
      inner = '<p>Muss es gleich die Kündigung sein? Vielleicht passt eine dieser Optionen besser:</p><div class="rrp-options">' +
        (haltZu ? '' : '<button type="button" class="rrp-option" data-action="open-pause" data-id="' + c.id + '"><span class="rrp-option__title">Lieferungen aussetzen</span><span class="rrp-option__desc">Ein paar Termine überspringen, ohne zu kündigen.</span></button>') +
        (haltZu ? '' : '<button type="button" class="rrp-option" data-action="retention-skip" data-id="' + c.id + '"><span class="rrp-option__title">Nächste Lieferung überspringen</span><span class="rrp-option__desc">Einfach eine Woche Luft holen.</span></button>') +
        (smaller && !haltZu ? '<button type="button" class="rrp-option" data-action="pick-box" data-id="' + c.id + '" data-variant="' + smaller.id + '" data-retention="1"><span class="rrp-option__title">Kleinere Box wählen</span><span class="rrp-option__desc">' + esc(smaller.product + (smaller.variant ? ' (' + smaller.variant + ')' : '') + ' für ' + money(smaller.price)) + ' – ab der nächsten Lieferung.</span></button>' : '') +
        (haltZu ? '<p class="rrp-small rrp-muted">Deine nächste Box ist schon in Vorbereitung und kommt noch. Danach ist Schluss, wenn du möchtest.</p>' : '') +
        '</div><div class="rrp-dialog__foot">' + btn('ghost', 'Trotzdem kündigen', 'open-cancel2') + btn('primary', 'Ich bleibe', 'close-dialog') + '</div>';
    } else if (state.dialog === 'cancel2') {
      title = 'Wirklich kündigen?';
      var spaeter = kuendigungSpaeter(c) && !(vorgemerkt(c) && c.kuendigungZum < new Date());
      inner = (spaeter
          ? '<p>Deine Lieferung am <strong>' + esc(fmtLong(nextDel)) + '</strong> ist schon fest und kommt noch; sie wird wie geplant abgerechnet. <strong>Danach endet dein Abo</strong>, weitere Abbuchungen gibt es nicht.</p>'
          : '<p>Dein Abo endet' + (nextDel ? ' vor der Lieferung am <strong>' + esc(fmtLong(nextDel)) + '</strong>' : ' sofort') + '. Danach retten wir ohne dich – schade drum.</p>') +
        '<div class="rrp-fields"><label class="rrp-field">Magst du uns sagen, warum? (optional)<input type="text" id="rrp-cancel-note" maxlength="200" placeholder="z. B. zu viel Gemüse, Umzug, Preis"></label></div>' +
        '<div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') +
        (spaeter ? btn('secondary', 'Zum ' + esc(fmtDatum(nextDel)) + ' kündigen', 'confirm-cancel-later', { id: c.id }) : btn('secondary', 'Abo beenden', 'confirm-cancel', { id: c.id })) + '</div>';
    } else if (state.dialog === 'address') {
      title = 'Lieferadresse bearbeiten';
      var a = d.address || c.address;
      inner = '<div class="rrp-fields"><div class="rrp-fields rrp-fields--2">' +
        '<label class="rrp-field">Vorname<input type="text" name="firstName" value="' + esc(a.firstName) + '" autocomplete="given-name"></label>' +
        '<label class="rrp-field">Nachname<input type="text" name="lastName" value="' + esc(a.lastName) + '" autocomplete="family-name"></label></div>' +
        '<label class="rrp-field">Straße &amp; Hausnummer<input type="text" name="address1" value="' + esc(a.address1) + '" autocomplete="address-line1"></label>' +
        '<label class="rrp-field">Adresszusatz<input type="text" name="address2" value="' + esc(a.address2) + '" autocomplete="address-line2"></label>' +
        '<div class="rrp-fields rrp-fields--2"><label class="rrp-field">PLZ<input type="text" name="zip" value="' + esc(a.zip) + '" autocomplete="postal-code" inputmode="numeric"></label>' +
        '<label class="rrp-field">Ort<input type="text" name="city" value="' + esc(a.city) + '" autocomplete="address-level2"></label></div>' +
        '<label class="rrp-field">Telefon (für Rückfragen der Fahrer:innen)<input type="tel" name="phone" value="' + esc(a.phone) + '" autocomplete="tel"></label>' +
        '<label class="rrp-field">Hinweis für die Zustellung<input type="text" name="note" value="' + esc(c.note) + '" maxlength="250" placeholder="z. B. Box bitte an die Kellertreppe stellen."></label></div>' +
        '<div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', 'Speichern', 'save-address', { id: c.id }) + '</div>';
    } else if (state.dialog === 'loy-redeem') {
      var lr = loyRules().filter(function (x) { return Number(x.id) === Number(d.rule); })[0] || {};
      title = 'Punkte einlösen';
      var rest = Number((state.loy.data && state.loy.data.availablePoints) || 0) - Number(lr.redeemPoints || 0);
      inner = '<p>Du tauschst <strong>' + esc(punkteWort(lr.redeemPoints)) + '</strong> gegen <strong>' + esc(ruleTitel(lr)) + '</strong>' + (Number(lr.minimumPurchaseAmount) > 0 ? ' (ab ' + esc(money(lr.minimumPurchaseAmount)) + ' Bestellwert)' : '') + '. Danach bleiben dir ' + esc(punkteWort(Math.max(0, rest))) + '.</p>' +
        '<p class="rrp-small rrp-muted">Du bekommst einen Code. Den legst du mit einem Tipp auf dein Abo, dann wird er bei der nächsten Abbuchung abgezogen. Einen noch ungenutzten Code kannst du über „Zurückgeben“ wieder in Punkte tauschen.</p>' +
        '<div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('cta', 'Jetzt einlösen', 'loy-confirm-redeem', { rule: lr.id }) + '</div>';
    } else if (state.dialog === 'loy-reward') {
      var rw = rewardsOffen(state.loy.data).filter(function (x) { return Number(x.id) === Number(d.reward); })[0];
      var rwExp = rw && parseDate(rw.expireDate);
      title = 'Das hat geklappt';
      var rwCode = rw && rw.discountCode && rw.rewardType !== 'STORE_CREDIT';
      var rwAbo = rwCode && aktiveAbos().length > 0 && !codeAufAbo(rw.discountCode);
      inner = rw
        ? '<p><strong>' + esc(rewardTitel(rw)) + '</strong> gehört dir' + (rwExp ? ', gültig bis ' + esc(fmtLong(rwExp)) : '') + '.</p>' +
          (rw.discountCode ? '<div class="rrp-loy-code"><code>' + esc(rw.discountCode) + '</code>' + btn('ghost', 'Kopieren', 'loy-copy', { code: rw.discountCode }, 'rrp-btn--sm') + '</div>' : '') +
          (rwCode && !rwAbo ? '<p class="rrp-small rrp-muted" style="margin-top:12px">Du hast gerade kein laufendes Abo. Der Code gilt an der Kasse für deine nächste Abo-Bestellung.</p>' : (rwAbo ? '<p class="rrp-small rrp-muted" style="margin-top:12px">Leg ihn jetzt auf dein Abo, dann wird er bei der nächsten Abbuchung abgezogen.</p>' : '')) +
          '<div class="rrp-dialog__foot">' + btn('ghost', rwAbo ? 'Später' : 'Alles klar', 'close-dialog') + (rwAbo ? btn('primary', 'Auf mein Abo anwenden', 'loy-apply', { code: rw.discountCode }) : '') + '</div>'
        : '<p>Deine Belohnung ist angelegt. Du findest sie unter „Deine Belohnungen“.</p><div class="rrp-dialog__foot">' + btn('primary', 'Alles klar', 'close-dialog') + '</div>';
    } else if (state.dialog === 'loy-apply') {
      title = 'Auf welches Abo?';
      inner = '<p>Du hast mehrere Abos. Auf welches soll der Code?</p><div class="rrp-options">' + state.contracts.filter(function (x) { return x.status === 'ACTIVE' || x.status === 'FAILED'; }).map(function (x) {
        var xd = deliveryDate(x);
        return '<button type="button" class="rrp-option" data-action="loy-apply" data-id="' + x.id + '" data-code="' + esc(d.code) + '"><span class="rrp-option__title">' + esc(boxTitle(x) + (boxSize(x) ? ' (' + boxSize(x) + ')' : '')) + '</span><span class="rrp-option__desc">' + esc((addressLine(x) ? addressLine(x) + ' · ' : '') + (xd ? 'nächste Lieferung ' + fmtShort(xd) : '')) + '</span></button>';
      }).join('') + '</div><div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + '</div>';
    } else if (state.dialog === 'loy-mail') {
      title = 'Per Mail einladen';
      inner = '<p>Wir schicken deinen Link mit einer kurzen Einladung an diese Adresse.</p><div class="rrp-fields"><label class="rrp-field">E-Mail-Adresse<input type="email" id="rrp-loy-mail" autocomplete="off" inputmode="email" placeholder="name@beispiel.de"></label></div>' +
        '<div class="rrp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', 'Einladung senden', 'loy-send-mail') + '</div>';
    }
    host.innerHTML = '<div class="rrp-backdrop" data-action="close-dialog"><div class="rrp-dialog rrp-actionable" role="dialog" aria-modal="true" aria-labelledby="rrp-dialog-title">' +
      '<div class="rrp-dialog__head"><h2 class="rrp-dialog__title" id="rrp-dialog-title">' + esc(title) + '</h2><button type="button" class="rrp-dialog__close" data-action="close-dialog" aria-label="Schließen">' + ICON.close + '</button></div>' + inner + '</div></div>';
    document.body.style.overflow = 'hidden';
    var first = host.querySelector('input, .rrp-pause-row, .rrp-option, .rrp-dialog__foot .rrp-btn');
    if (first) first.focus();
  }

  function renderToast() {
    var host = document.getElementById('rrp-toast-host');
    if (!host) { host = document.createElement('div'); host.id = 'rrp-toast-host'; host.className = 'rrp rrp--overlay rrp-toast-wrap'; document.body.appendChild(host); }
    host.innerHTML = state.toast ? '<div class="rrp-toast' + (state.toast.variant === 'error' ? ' rrp-toast--error' : '') + '" role="status">' + esc(state.toast.msg) + '</div>' : '';
  }

  function headerHtml(lead) { return '<header class="rrp__header"><h1 class="rrp__h1">Meine Abos</h1>' + (lead ? '<p class="rrp__lead">' + esc(lead) + '</p>' : '') + '</header>'; }
  function renderLoginGate() {
    app.innerHTML = headerHtml('Hier verwaltest du deine Boxen, Liefertermine und Extras.') +
      '<div class="rrp-card rrp-card--pad rrp-login"><h2 class="rrp__h2 rrp__h2--sm">Erst einloggen, dann retten.</h2><p>Melde dich mit deinem Kundenkonto an, damit wir dir deine Abos zeigen können.</p><p class="rrp-small rrp-muted" style="margin-top:8px">Du bist schon in deinem Shopify-Konto angemeldet und siehst das trotzdem? Dann einmal hier auf „Anmelden“ klicken, danach kennt dich auch der Shop.</p>' +
      '<div class="rrp-actions"><a class="rrp-btn rrp-btn--primary" href="' + esc(cfg.loginUrl) + '">Anmelden</a><a class="rrp-btn rrp-btn--ghost" href="' + esc(cfg.registerUrl) + '">Konto anlegen</a></div></div>';
  }

  function render() {
    if (state.needsLogin) { renderLoginGate(); return; }
    if (state.error) {
      app.innerHTML = headerHtml('') + '<div class="rrp-card rrp-card--pad rrp-error"><h2 class="rrp__h2 rrp__h2--sm">Da hakt gerade etwas.</h2><p class="rrp-small">Wir konnten deine Abos nicht laden. Versuch es gleich noch einmal oder schreib uns.</p><code>' + esc(state.error) + '</code><div class="rrp-actions">' + btn('primary', 'Noch einmal versuchen', 'retry') + '</div></div>';
      return;
    }
    var c = selected();
    app.innerHTML = c ? renderDetail(c) : state.tab === 'punkte' ? renderPunkte() : state.tab === 'werben' ? renderWerben() : renderOverview();
    renderDialog();
    renderToast();
    debugPanel();
    scrollBoxRowToActive();
    extrasNavAufsetzen();
  }
  /* --- Wischbare Extras-Reihe ------------------------------------------------
     render() ersetzt das Markup komplett. Ohne das hier spraenge die Reihe nach
     jedem "Hinzufuegen" zurueck an den Anfang, und die Pfeiltasten verloeren
     ihren Zustand. Die Lauschfunktionen haengen an den neuen Knoten und
     verschwinden mit ihnen. */
  var extrasScroll = 0;
  function extrasNavAufsetzen() {
    var reihe = app.querySelector('.rrp-extras');
    var nav = app.querySelector('[data-rrp-extras-nav]');
    if (!reihe || !nav) return;
    var zurueck = nav.querySelector('[data-action="extras-prev"]');
    var vor = nav.querySelector('[data-action="extras-next"]');
    if (extrasScroll > 0) reihe.scrollLeft = extrasScroll;
    function stand() {
      var max = reihe.scrollWidth - reihe.clientWidth;
      /* Passt alles ins Bild, braucht es keine Pfeile */
      nav.classList.toggle('rrp-extras__nav--aus', max <= 1);
      if (zurueck) zurueck.disabled = reihe.scrollLeft <= 1;
      if (vor) vor.disabled = reihe.scrollLeft >= max - 1;
    }
    reihe.addEventListener('scroll', function () { extrasScroll = reihe.scrollLeft; stand(); }, { passive: true });
    if (window.ResizeObserver) {
      var beobachter = new ResizeObserver(stand);
      beobachter.observe(reihe);
    }
    stand();
  }
  /* Ein Schritt ist so breit wie eine Karte samt Abstand. */
  function extrasSchritt(richtung) {
    var reihe = app.querySelector('.rrp-extras'); if (!reihe) return;
    var karte = reihe.querySelector('.rrp-extra');
    var abstand = parseFloat(getComputedStyle(reihe).columnGap || getComputedStyle(reihe).gap) || 12;
    var weite = karte ? karte.getBoundingClientRect().width + abstand : reihe.clientWidth * 0.8;
    reihe.scrollBy({ left: richtung * weite, behavior: 'smooth' });
  }
  /* Wischbare Box-Zeile: aufgeklappte Karte ohne Seitensprung in den sichtbaren Bereich holen */
  function scrollBoxRowToActive() {
    var row = app.querySelector('.rrp-boxes'); if (!row) return;
    var card = row.querySelector('.rrp-box.is-active'); if (!card) return;
    var left = card.offsetLeft - row.offsetLeft;
    var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
    var target = Math.max(0, left - pad);
    if (target < row.scrollLeft || left + card.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = target;
  }

  function smallerBox(c) {
    if (!c.box) return null;
    var cur = boxVariants[c.box.variantId];
    var candidates = (cfg.boxes || []).filter(function (x) { return x.available !== false && x.id !== c.box.variantId && (!cur || x.productId === cur.productId) && x.price < (cur ? cur.price : c.box.price); });
    candidates.sort(function (a, b) { return b.price - a.price; });
    return candidates[0] || null;
  }

  /* ---------- Fehlermeldungen ----------
     Appstle antwortet im Rohformat: technischer Praefix, Siezen, Statuscode.
     Das gehoert nicht vor den Kunden. */
  function fehlerDetail(err) {
    var roh = err && err.message ? String(err.message) : '';
    return roh.replace(/^\s*[A-Za-z]*(?:Error|Exception)\s*:\s*/, '').trim();
  }
  function shopMail() { return cfg.shopEmail || 'info@ruebenretter.de'; }
  /* Kein Versprechen, ab wann es wieder geht: das entscheidet der Einzelfall.
     Der Kunde schreibt uns, wir kuemmern uns. */
  function cutoffHinweis() {
    return 'Deine nächste Box ist schon in Vorbereitung. Schreib uns kurz an ' + shopMail() + ' – wir kümmern uns darum.';
  }
  function cutoffHinweisTermin() {
    return 'Diese Lieferung ist schon in Vorbereitung. Schreib uns kurz an ' + shopMail() + ' – wir schauen, was sich noch machen lässt.';
  }
  /* Wenn Appstle etwas ablehnt, das wir nicht uebersetzen koennen: nicht die
     Rohmeldung zeigen, sondern den Weg zu uns. Die Rohmeldung steht in
     state.lastError und in der Konsole, fuer den Support. */
  function allgemeinHinweis() {
    return 'Das lässt sich hier gerade nicht abschließen. Schreib uns kurz an ' + shopMail() + ' – wir erledigen das für dich.';
  }
  /* Englische Technikmeldungen gehoeren nicht vor den Kunden. Appstle antwortet
     je nach Regel mal deutsch, mal englisch ("Subscription requires minimum
     billing iterations of 2 before it can be cancelled"). */
  function istTechnisch(roh) {
    return /\b(subscription|cannot|can not|requires?|minimum|billing|iterations?|allowed|invalid|failed|exception|null|undefined)\b/i.test(roh);
  }
  function fehlerText(err) {
    var roh = fehlerDetail(err);
    /* Appstles eigener Bestellschluss, in unserer Ansprache */
    if (/nicht vor\s+\d+\s+Tag/i.test(roh) || /(cancel|pause).{0,40}\b\d+\s*day/i.test(roh)) return cutoffHinweis();
    if (!roh) return 'Das hat leider nicht geklappt.';
    if (istTechnisch(roh)) return allgemeinHinweis();
    var status = err && err.status;
    /* Statuscode nur bei Server- und Netzfehlern – bei 4xx steht der Grund schon im Text */
    if (status >= 500 && roh.indexOf(String(status)) === -1) roh += ' (Status ' + status + ')';
    return 'Das hat leider nicht geklappt: ' + roh;
  }

  /* ---------- Aktionen ---------- */
  /* Aktion ausführen. opts.optimistic(c) ändert den Stand sofort im Portal (kein Ausgrauen, keine Wartezeit),
     danach bestätigt der Vertrag von Appstle den Stand. Schlägt es fehl, wird der echte Stand geladen. */
  function run(promise, okMsg, id, opts) {
    opts = opts || {};
    var c = id ? state.contracts.filter(function (x) { return x.id === id; })[0] : null;
    var optimistic = false;
    if (opts.optimistic && c) {
      try { opts.optimistic(c); optimistic = true; } catch (e) {}
    }
    if (optimistic) { app.classList.add('is-saving'); render(); if (okMsg) showToast(okMsg); }
    else setBusy(true);
    var finish = function () { setBusy(false); app.classList.remove('is-saving'); };
    return promise.then(function () {
      /* Aktion war erfolgreich – ein Fehler beim Neuladen darf sie nicht als gescheitert melden */
      return id ? reloadContract(id).then(null, function () {}) : null;
    }).then(function () {
      finish(); render();
      if (okMsg && !optimistic) showToast(okMsg);
    }, function (err) {
      /* Fehlgeschlagen oder teilweise ausgeführt: echten Stand laden, damit nichts Falsches stehen bleibt */
      var refresh = (id && (optimistic || (err && err.partial))) ? reloadContract(id).then(null, function () {}) : Promise.resolve();
      return refresh.then(function () {
        finish(); render();
        showToast(fehlerText(err), 'error');
      });
    });
  }
  /* Mehrere Appstle-Aufrufe mit begrenzter Parallelität (schneller als nacheinander, schonender als alle auf einmal) */
  function runBatch(items, worker, limit) {
    var i = 0, done = 0, failed = null;
    function next() {
      if (failed || i >= items.length) return Promise.resolve();
      var item = items[i++];
      return worker(item).then(function () { done++; }, function (err) { failed = failed || err; }).then(next);
    }
    var lanes = []; for (var k = 0; k < Math.min(limit || 3, items.length); k++) lanes.push(next());
    return Promise.all(lanes).then(function () {
      if (!failed) return done;
      if (!done) throw failed;
      var e = new Error(done + ' von ' + items.length + ' erledigt, dann kam: ' + (failed && failed.message));
      e.status = failed && failed.status; e.partial = true; throw e;
    });
  }
  function markAttempt(c, attemptId, status) {
    [c.attempts, c.history].forEach(function (list) { (list || []).forEach(function (a) { if (String(a.id) === String(attemptId)) a.status = status; }); });
  }

  var actions = {
    'retry': function () { init(); },
    /* [RR feat] Treuepunkte */
    'tab': function (d) { zeigeTab(d.tab); },
    'loy-reload': function () { state.loy.geladen = false; render(); loyLaden(true).then(render, render); },
    'loy-join': function () {
      setBusy(true);
      loyApi('POST', '/enable-loyalty-program').then(function () { return loyLaden(true); }).then(function () {
        setBusy(false); render(); showToast('Willkommen im Programm. Ab jetzt zählt jede Lieferung.');
      }, function (err) { setBusy(false); render(); showToast(loyFehler(err), 'error'); });
    },
    'loy-redeem': function (d) { state.dialog = 'loy-redeem'; state.dialogData = { rule: Number(d.rule) }; renderDialog(); },
    'loy-confirm-redeem': function (d) {
      var r = loyRules().filter(function (x) { return Number(x.id) === Number(d.rule); })[0];
      if (!r) return;
      state.dialog = null; state.dialogData = {}; renderDialog(); setBusy(true);
      var vorher = rewardsOffen(state.loy.data).map(function (x) { return x.id; });
      loyApi('POST', '/redeem-points', { body: { redeemRuleId: r.id } }).then(function (res) {
        if (res && typeof res === 'object' && 'availablePoints' in res) state.loy.data = res;
        var neu = rewardsOffen(state.loy.data).filter(function (x) { return vorher.indexOf(x.id) < 0; })[0];
        setBusy(false);
        state.dialog = neu ? 'loy-reward' : null; state.dialogData = { reward: neu ? neu.id : null };
        render();
        if (!neu) showToast('Eingelöst. Deine Belohnung findest du unter „Deine Belohnungen“.');
        loyLaden(true).then(function () { if (!state.dialog) render(); }, function () {});
      }, function (err) { setBusy(false); render(); showToast(loyFehler(err), 'error'); });
    },
    'loy-copy': function (d) {
      kopieren(String(d.code || '')).then(function () { showToast('Kopiert.'); }, function () { showToast('Kopieren hat nicht geklappt – markiere den Text und kopiere ihn von Hand.', 'error'); });
    },
    'loy-share': function (d) {
      var t = loyReferralText();
      var text = 'Ich rette mit Rübenretter krummes Gemüse vom Feld. ' + (t.sie ? 'Mit meinem Link bekommst du ' + t.sie + ':' : 'Hier ist mein Link:');
      if (navigator.share) navigator.share({ title: 'Rübenretter', text: text, url: d.url }).catch(function () {});
      else actions['loy-copy']({ code: d.url });
    },
    'loy-mail': function () { state.dialog = 'loy-mail'; state.dialogData = {}; renderDialog(); },
    'loy-send-mail': function () {
      var input = document.getElementById('rrp-loy-mail');
      var mail = input ? input.value.trim() : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { showToast('Bitte eine gültige E-Mail-Adresse eingeben.', 'error'); if (input) input.focus(); return; }
      state.dialog = null; state.dialogData = {}; renderDialog(); setBusy(true);
      loyApi('POST', '/send-customer-referral-url', { body: { email: mail } }).then(function () {
        setBusy(false); render(); showToast('Einladung an ' + mail + ' ist raus.');
        loyLaden(true).then(function () { if (!state.dialog) render(); }, function () {});
      }, function (err) { setBusy(false); render(); showToast(loyFehler(err), 'error'); });
    },
    'loy-apply': function (d) {
      var aktiv = aktiveAbos();
      if (!aktiv.length) { showToast('Du hast gerade kein laufendes Abo, auf das wir den Code legen können. Kopier ihn dir für die Kasse.', 'error'); return; }
      var ziel = d.id ? aktiv.filter(function (c) { return c.id === Number(d.id); })[0] : (aktiv.length === 1 ? aktiv[0] : null);
      if (!ziel) { state.dialog = 'loy-apply'; state.dialogData = { code: d.code }; renderDialog(); return; }
      state.dialog = null; state.dialogData = {}; renderDialog();
      /* Kein run(): der Stand soll in der Belohnungskarte stehen, nicht nur in der Einblendung */
      state.loy.codes[d.code] = { laeuft: true };
      setBusy(true); render();
      /* Zur Karte scrollen, damit die Rueckmeldung im Blick ist */
      var karte = app.querySelector('.rrp-loy-rewards'); if (karte) karte.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      Appstle.applyDiscount(ziel.id, d.code).then(function () {
        return reloadContract(ziel.id).then(null, function () {});
      }).then(function () {
        state.loy.codes[d.code] = { ok: true, abo: boxTitle(ziel) };
        setBusy(false); render(); showToast('Der Code liegt auf deinem Abo und wird bei der nächsten Abbuchung abgezogen.');
        loyLaden(true).then(function () { if (!state.dialog) render(); }, function () {});
      }, function (err) {
        state.loy.codes[d.code] = { fehler: fehlerText(err), roh: (fehlerDetail(err) || '').slice(0, 400) + (err && err.status ? ' (Status ' + err.status + ')' : '') };
        setBusy(false); render(); showToast(fehlerText(err), 'error');
      });
    },
    'loy-return': function (d) {
      setBusy(true);
      loyApi('POST', '/return-reward/' + Number(d.reward)).then(function (res) {
        if (res && typeof res === 'object' && 'availablePoints' in res) state.loy.data = res;
        setBusy(false); render(); showToast('Zurückgegeben – die Punkte sind wieder auf deinem Konto.');
        loyLaden(true).then(function () { if (!state.dialog) render(); }, function () {});
      }, function (err) { setBusy(false); render(); showToast(loyFehler(err), 'error'); });
    },

    'extras-prev': function () { extrasSchritt(-1); },
    'extras-next': function () { extrasSchritt(1); },
    'open': function (d) {
      var c = state.contracts.filter(function (x) { return x.id === Number(d.id); })[0];
      if (!c) return;
      state.selectedId = c.id; state.dialog = null; state.boxProduct = null; state.tab = 'abos';
      try { history.replaceState(null, '', location.pathname + '?abo=' + c.id); } catch (e) {}
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
      render();
      var p = loadDetailData(c); if (p) p.then(render);
    },
    'back': function () {
      state.selectedId = null; state.dialog = null;
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      render();
    },
    'close-dialog': function () { state.dialog = null; state.dialogData = {}; renderDialog(); },
    'open-pause': function (d) {
      state.dialog = 'pause'; state.dialogData = { count: 2 }; renderDialog();
      var c = selected();
      var p = c && loadDetailData(c); if (p) p.then(function () { if (state.dialog === 'pause') renderDialog(); });
    },
    'pause-count': function (d) { state.dialogData.count = Number(d.count) || 1; renderDialog(); },
    'confirm-pause': function (d) {
      var c = selected(); if (!c) return;
      var opts = pauseOptions(c).slice(0, Number(d.count) || 1);
      if (!opts.length) return;
      state.dialog = null; state.dialogData = {}; renderDialog();
      var withIds = opts.every(function (o) { return o.id; });
      /* Mit Termin-IDs parallel überspringen; ohne IDs muss es nacheinander gehen (skip-upcoming nimmt immer den nächsten) */
      var chain = withIds ? runBatch(opts, function (o) { return Appstle.skip(c.id, o.id); }, 3)
        : runBatch(opts, function () { return Appstle.skipUpcoming(c.id); }, 1);
      var last = deliveryDate(c, opts[opts.length - 1].billing);
      run(chain, opts.length === 1 ? 'Alles klar – ' + fmtShort(last) + ' wird übersprungen.' : 'Ausgesetzt bis ' + fmtShort(last) + ' – wir halten die Rüben solange warm.', c.id,
        withIds ? { optimistic: function (x) { opts.forEach(function (o) { markAttempt(x, o.id, 'SKIPPED'); }); } } : null);
    },
    'resume': function (d) {
      var c = selected(); if (!c) return;
      run(Appstle.status(c.id, 'ACTIVE'), 'Willkommen zurück! Deine nächste Box ist unterwegs zum nächsten Termin.', c.id, { optimistic: function (x) { x.status = 'ACTIVE'; } });
    },
    'reactivate': function (d) {
      var c = byId(Number(d.id)); if (!c) return;
      run(Appstle.status(c.id, 'ACTIVE'), '„' + boxTitle(c) + '“ ist wieder aktiv. Willkommen zurück!', c.id);
    },
    'skip-next': function (d) {
      var c = selected(); if (!c) return;
      var na = nextAttempt(c);
      var del = deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate);
      run(na ? Appstle.skip(c.id, na.id) : Appstle.skipUpcoming(c.id), 'Alles klar – ' + fmtShort(del) + ' wird übersprungen.', c.id, na ? { optimistic: function (x) { markAttempt(x, na.id, 'SKIPPED'); } } : null);
    },
    'retention-skip': function (d) {
      var c = selected(); if (!c) return;
      state.dialog = null; renderDialog();
      var na = nextAttempt(c);
      var del = deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate);
      run(na ? Appstle.skip(c.id, na.id) : Appstle.skipUpcoming(c.id), fmtShort(del) + ' wird übersprungen – schön, dass du bleibst.', c.id, na ? { optimistic: function (x) { markAttempt(x, na.id, 'SKIPPED'); } } : null);
    },
    'skip': function (d) { var c = selected(); if (!c) return; run(Appstle.skip(c.id, d.attempt), 'Lieferung übersprungen.', c.id, { optimistic: function (x) { markAttempt(x, d.attempt, 'SKIPPED'); } }); },
    'unskip': function (d) { var c = selected(); if (!c) return; run(Appstle.unskip(c.id, d.attempt), 'Diese Woche wird wieder geliefert.', c.id, { optimistic: function (x) { markAttempt(x, d.attempt, 'QUEUED'); } }); },
    'unskip-all': function (d) {
      var c = selected(); if (!c) return;
      var list = queuedAttempts(c).filter(function (a) { return String(a.status).toUpperCase() === 'SKIPPED'; });
      if (!list.length) return;
      var chain = runBatch(list, function (a) { return Appstle.unskip(c.id, a.id); }, 3);
      run(chain, 'Pause beendet – ' + (list.length === 1 ? 'die Lieferung kommt' : 'alle ' + list.length + ' Lieferungen kommen') + ' wieder wie gewohnt.', c.id,
        { optimistic: function (x) { list.forEach(function (a) { markAttempt(x, a.id, 'QUEUED'); }); } });
    },
    'open-cancel': function () { state.dialog = 'cancel1'; renderDialog(); },
    'open-cancel2': function () { state.dialog = 'cancel2'; renderDialog(); },
    'confirm-cancel': function (d) {
      var c = selected(); if (!c) return;
      var noteEl = document.getElementById('rrp-cancel-note');
      var note = noteEl ? noteEl.value.trim() : '';
      state.dialog = null; renderDialog();
      run(Appstle.cancel(c.id, note ? 'OTHER' : '', note), 'Dein Abo ist gekündigt. Die Tür bleibt offen.', c.id);
    },
    /* Kuendigung zum Liefertag vormerken: Attribute am Vertrag, Shopify Flow kuendigt nach der Abbuchung */
    'confirm-cancel-later': function (d) {
      var c = selected(); if (!c) return;
      var na = nextAttempt(c);
      var tag = deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate);
      if (!tag) { actions['confirm-cancel'](d); return; }
      var noteEl = document.getElementById('rrp-cancel-note');
      var note = noteEl ? noteEl.value.trim() : '';
      state.dialog = null; renderDialog();
      var liste = [{ key: KUEND_KEY, value: isoDatum(tag) }, { key: KUEND_LABEL, value: fmtDatum(tag) + (note ? ' · ' + note.slice(0, 120) : '') }];
      run(Appstle.attributes(c.id, liste), 'Vorgemerkt: Deine Box am ' + fmtShort(tag) + ' kommt noch, danach endet dein Abo.', c.id, {
        optimistic: function (x) { x.kuendigungZum = tag; x.attrs[KUEND_KEY] = isoDatum(tag); }
      });
    },
    'cancel-withdraw': function (d) {
      var c = selected(); if (!c) return;
      run(Appstle.attributes(c.id, [{ key: KUEND_KEY, value: '' }, { key: KUEND_LABEL, value: '' }]), 'Kündigung zurückgenommen. Dein Abo läuft weiter.', c.id, {
        optimistic: function (x) { x.kuendigungZum = null; x.attrs[KUEND_KEY] = ''; }
      });
    },
    'pick-product': function (d) {
      state.boxProduct = Number(d.product) || null;
      render();
      var sizes = app.querySelector('.rrp-sizes');
      if (sizes && sizes.scrollIntoView) sizes.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    },
    'pick-box': function (d) {
      var c = selected(); if (!c || !c.box) return;
      var v = boxVariants[Number(d.variant)]; if (!v || v.id === c.box.variantId) return;
      if (d.retention) {
        state.dialog = null; renderDialog();
        actions['confirm-swap']({ id: c.id, variant: v.id });
        return;
      }
      state.dialog = 'swap'; state.dialogData = { variant: v.id }; renderDialog();
    },
    'confirm-swap': function (d) {
      var c = selected(); if (!c || !c.box) return;
      var v = boxVariants[Number(d.variant)]; if (!v || v.id === c.box.variantId) return;
      state.dialog = null; state.dialogData = {}; renderDialog();
      state.boxProduct = v.productId;
      run(Appstle.replaceVariant(c.id, c.box, v.id), v.product + (v.variant ? ' (' + v.variant + ')' : '') + ' ab der nächsten Lieferung. Gute Wahl.', c.id,
        { optimistic: function (x) { if (!x.box) return; x.box.variantId = v.id; x.box.productId = v.productId; x.box.title = v.product; x.box.variantTitle = v.variant || ''; x.box.price = v.price; x.box.lineTotal = v.price * (x.box.quantity || 1); } });
    },
    'pick-frequency': function (d) {
      var c = selected(); if (!c) return;
      var f = (c.frequencies || [])[Number(d.index)]; if (!f) return;
      /* Laeuft das Abo schon so, wird nichts gesendet. Appstle rechnet bei jedem
         Frequenzwechsel den naechsten Termin neu ("Immediately update next order date
         when frequency changes", Methode "Current Next Billing Date"): der neue Termin
         ist der aktuelle plus ein Intervall. Ein Tipp auf den bereits aktiven Rhythmus
         haette die Lieferung also um einen vollen Zyklus nach hinten geschoben, ohne
         dass sich etwas geaendert haette. Mehrere Tipps summieren sich. */
      if (istAktiverRhythmus(c, f)) { showToast('Dein Abo läuft schon in diesem Rhythmus.'); return; }
      run(Appstle.setFrequency(c.id, f), 'Neuer Rhythmus gespeichert.', c.id, { optimistic: function (x) {
        (x.frequencies || []).forEach(function (o) { o.selected = (o === f); });
        if (x.box && f.sellingPlanId) x.box.sellingPlanId = f.sellingPlanId;
      } });
    },
    'extra-inc': function (d) {
      var c = selected(); if (!c) return;
      var vid = Number(d.variant);
      var line = c.extras.filter(function (l) { return l.variantId === vid; })[0];
      var p = extraVariants[vid];
      run(line ? Appstle.lineQty(c.id, line.lineId, line.quantity + 1) : Appstle.addLine(c.id, vid, 1), (p ? p.name : 'Extra') + ' kommt in die nächste Box.', c.id);
    },
    'extra-dec': function (d) {
      var c = selected(); if (!c) return;
      var vid = Number(d.variant);
      var line = c.extras.filter(function (l) { return l.variantId === vid; })[0]; if (!line) return;
      run(line.quantity > 1 ? Appstle.lineQty(c.id, line.lineId, line.quantity - 1) : Appstle.removeLine(c.id, line.lineId), line.quantity > 1 ? 'Menge angepasst.' : 'Extra entfernt.', c.id);
    },
    'open-address': function () { state.dialog = 'address'; state.dialogData = {}; renderDialog(); },
    'save-address': function (d) {
      var c = selected(); if (!c) return;
      var host = document.getElementById('rrp-dialog-host');
      var get = function (n) { var el = host.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
      var addr = {
        firstName: get('firstName'), lastName: get('lastName'), address1: get('address1'), address2: get('address2'),
        city: get('city'), zip: get('zip'), phone: get('phone'),
        company: c.address.company, province: c.address.province, provinceCode: c.address.provinceCode,
        country: c.address.country || 'Germany', countryCode: c.address.countryCode || 'DE'
      };
      var note = get('note');
      if (!addr.address1 || !addr.zip || !addr.city) { showToast('Straße, PLZ und Ort brauchen wir mindestens.', 'error'); return; }
      state.dialog = null; renderDialog();
      var jobs = [Appstle.address(c.id, addr)];
      if (note !== (c.note || '')) jobs.push(Appstle.note(c.id, note));
      run(Promise.all(jobs), 'Adresse gespeichert.', c.id);
    },
    'payment': function (d) {
      var c = selected(); if (!c) return;
      run(Appstle.paymentEmail(c.id), 'Wir haben dir einen sicheren Link zum Ändern der Zahlart gemailt.', null);
    }
  };

  /* Bestellschluss zusaetzlich beim Klick pruefen: zwischen Rendern und Klick kann der
     Tag wechseln, und ein disabled laesst sich im Browser entfernen. Die Sperre ist damit
     nicht nur eine Anzeige. Verbindlich bleibt ohnehin, was Appstle annimmt. */
  var CUTOFF_VERTRAG = { 'skip-next': 1, 'unskip-all': 1, 'open-pause': 1, 'pause-count': 1, 'confirm-pause': 1, 'pick-box': 1, 'confirm-swap': 1, 'pick-frequency': 1, 'extra-inc': 1, 'extra-dec': 1, 'retention-skip': 1 };
  /* Kuendigen nur sperren, wenn es eingeschaltet ist. Siehe docs/abo-portal-bestellschluss.md
     zum Vorbehalt aus § 312k BGB. */
  var CUTOFF_KUENDIGUNG = { 'open-cancel': 1, 'open-cancel2': 1, 'confirm-cancel': 1 };
  var CUTOFF_TERMIN = { 'skip': 1, 'unskip': 1 };
  function cutoffBlockiert(aktion, daten) {
    if (!cutoffTage()) return false;
    var c = selected(); if (!c) return false;
    if (c.status !== 'ACTIVE' && c.status !== 'FAILED') return false;
    if (CUTOFF_KUENDIGUNG[aktion]) return false; /* Kuendigen ist immer moeglich, im Fenster wird sie vorgemerkt */
    if (CUTOFF_VERTRAG[aktion]) return aboGesperrt(c);
    if (CUTOFF_TERMIN[aktion]) {
      var a = (c.attempts || []).filter(function (x) { return String(x.id) === String(daten && daten.attempt); })[0];
      return a ? terminGesperrt(deliveryDate(c, parseDate(a.billingDate))) : aboGesperrt(c);
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    if (MOUNT !== window.__rrpMount) return;
    var el = e.target.closest('[data-action]');
    if (!el) return;
    if (el.closest('#rrp-dialog-host') || root.contains(el)) {
      /* Klicks im Dialog nicht als Backdrop-Klick werten */
      if (el.classList.contains('rrp-backdrop') && e.target !== el) return;
      if (state.busy && el.dataset.action !== 'close-dialog') return;
      var fn = actions[el.dataset.action];
      if (fn) {
        e.preventDefault();
        if (cutoffBlockiert(el.dataset.action, el.dataset)) {
          showToast(CUTOFF_KUENDIGUNG[el.dataset.action]
            ? cutoffHinweis()
            : cutoffHinweisTermin());
          return;
        }
        fn(el.dataset, el, e);
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (MOUNT !== window.__rrpMount) return;
    if (e.key === 'Escape' && state.dialog) actions['close-dialog']();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.rrp-sub[data-action="open"]')) { e.preventDefault(); actions.open(e.target.dataset); }
  });

  /* ---------- Start ---------- */
  function resolveCustomer() {
    if (cfg.customerId) return Promise.resolve(cfg.customerId);
    /* Liquid kennt keinen Kunden – Appstle fragen, ob eine Kundensession besteht */
    return api('GET', '/logged-in-customer').then(function (res) {
      var id = num(res && (res.customerId || res.id || res));
      if (!id) throw new Error('not logged in');
      cfg.customerId = id;
      return id;
    });
  }

  var DEBUG = /[?&]rrp_debug=1/.test(location.search), debugProbe = null;
  function debugPanel() {
    if (!DEBUG) return;
    var old = document.getElementById('rrp-debug'); if (old) old.parentNode.removeChild(old);
    var box = document.createElement('pre');
    box.id = 'rrp-debug';
    box.style.cssText = 'margin-top:24px;padding:12px;background:#fff;border:1px dashed #E3E3D2;border-radius:8px;font-size:12px;white-space:pre-wrap;color:#4A5F53';
    box.textContent = 'Diagnose\nLiquid-Kunde: ' + (cfg.customerId || 'keiner') + '\nProxy-Basis: ' + API_BASE + '\nStatus: ' + (state.needsLogin ? 'keine Kundensession' : state.error ? 'Fehler: ' + state.error : 'ok, ' + state.contracts.length + ' Verträge') +
      (state.lastError ? '\nLetzter API-Fehler: ' + state.lastError.method + ' ' + state.lastError.url + '\n  Status ' + state.lastError.status + ': ' + state.lastError.body : '') +
      (function () { var c = selected(); if (!c) return ''; return '\nTermine (top-orders): ' + (c.attempts ? c.attempts.length + ' → ' + c.attempts.map(function (a) { return a.status + '@' + String(a.billingDate).slice(0, 10); }).join(', ') : 'nicht geladen') +
        '\nHistorie (past-orders): ' + (c.history ? c.history.length + ' → ' + c.history.map(function (a) { return a.status + '@' + String(a.billingDate).slice(0, 10); }).join(', ') : 'nicht geladen') +
        '\nRoh top-orders: ' + (state.debugRaw.topOrders || '–') + '\nRoh past-orders: ' + (state.debugRaw.pastOrders || '–') +
        '\nRoh fulfillments: ' + (state.debugRaw.fulfillments || '–') + '\nErkannt: ' + JSON.stringify(c.fulfillments || {}); })();
    var keepErr = state.lastError;
    debugProbe = debugProbe || api('GET', '/logged-in-customer').then(function (r) { return 'logged-in-customer: ' + JSON.stringify(r).slice(0, 200); }, function (e) { state.lastError = keepErr; return 'logged-in-customer: Fehler ' + (e.status || '') + ' ' + String(e.message).slice(0, 200); });
    debugProbe.then(function (t) { box.textContent += '\n' + t; });
    app.appendChild(box);
  }

  /* Theme-Editor: kein Kunde, kein Appstle – Beispieldaten, damit sich die Section einrichten lässt */
  function loadDemo() {
    var b = (cfg.boxes || [])[0] || { id: 0, productId: 0, product: 'Gemüse-Box', variant: 'Für 1-2 Personen', price: 27.99 };
    var next = new Date(); next.setDate(next.getDate() + ((3 - next.getDay() + 7) % 7 || 7) - Number(cfg.deliveryOffsetDays || 0));
    var mk = function (i, status) { return { id: 9000 + i, status: status, billingDate: addDays(next, i * 7).toISOString() }; };
    var c = normalizeContract({
      id: 1, status: 'ACTIVE', nextBillingDate: next.toISOString(), createdAt: addDays(next, -120).toISOString(),
      billingPolicy: { interval: 'WEEK', intervalCount: 1 }, deliveryPolicy: { interval: 'WEEK', intervalCount: 1 },
      lines: [{ id: 'demo-line', variantId: b.id, productId: b.productId, title: b.product, variantTitle: b.variant, quantity: 1, currentPrice: { amount: String(b.price) }, sellingPlanId: (b.plans && b.plans[0]) ? b.plans[0].id : null }],
      deliveryMethod: { address: { firstName: 'Jana', lastName: 'Beispiel', address1: 'Ackerweg 12', zip: '92318', city: 'Neumarkt' } },
      customerPaymentMethod: { instrument: { brand: 'visa', lastDigits: '4242', expiryMonth: 2, expiryYear: 2028 } },
      customAttributes: []
    });
    c.attempts = [0, 1, 2, 3, 4, 5].map(function (i) { return mk(i, i === 1 ? 'SKIPPED' : 'QUEUED'); });
    c.history = [1, 2, 3].map(function (i) { return { id: 8000 + i, status: 'SUCCESS', billingDate: addDays(next, -i * 7).toISOString(), orderName: '#10' + (40 - i), orderAmount: b.price }; });
    /* Die juengste Bestellung ist bezahlt, aber noch nicht raus; die aelteren sind geliefert. */
    c.fulfillments = { '1039': false, '1038': true, '1037': true };
    c.frequencies = liquidFrequencies(c);
    state.contracts = [c];
    if (!cfg.customerFirstName) cfg.customerFirstName = 'Jana';
    /* [RR feat] Treuepunkte in der Vorschau: Beispielstand, damit Menue und Karten im Editor zu sehen sind */
    if (loyOn()) {
      state.loy.data = { availablePoints: 42.5, pendingPoints: 1.8, creditedPoints: 74.5, referredCompleted: 1, referralLink: 'https://referral.appstle.com/beispiel', customerStatus: 'ACTIVE',
        rewards: [{ id: 1, discountCode: 'RR-BEISPIEL', amount: 10, status: 'UNUSED', rewardType: 'DISCOUNT_CODE', expireDate: addDays(next, 60).toISOString() }] };
      state.loy.verlauf = [
        { id: 3, pointType: 'CREDIT', points: 1.7, status: 'APPROVED', transactionRule: 'EARN_RULE', orderName: '#1040', createAt: addDays(next, -7).toISOString() },
        { id: 2, pointType: 'DEBIT', points: 30, status: 'APPROVED', transactionRule: 'REDEEM_RULE', createAt: addDays(next, -14).toISOString() },
        { id: 1, pointType: 'CREDIT', points: 5, status: 'APPROVED', transactionRule: 'REFERRAL', createAt: addDays(next, -21).toISOString() }
      ];
      state.loy.referrals = [{ id: 1, referredEmailId: 'm***a@web.de', status: 'CLAIMED', referralRewarded: true, createAt: addDays(next, -21).toISOString() }];
      state.loy.geladen = true;
    }

    if (!(cfg.orders || []).length) {
      var y = new Date().getFullYear(), m0 = new Date().getMonth();
      cfg.orders = [6, 5, 4, 3, 2, 1, 0].map(function (k) { var d = new Date(y, m0 - k, 8); return { date: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(), grams: 5200 + k * 300, boxes: 1, cancelled: false }; });
      cfg.ordersCount = cfg.orders.length;
    }
    render();
    var note = document.createElement('div');
    note.className = 'rrp-card rrp-card--tip rrp-card--pad rrp-demo-note';
    note.textContent = 'Vorschau im Theme-Editor: Beispieldaten ohne Verbindung zu Appstle. Eingeloggte Kund:innen sehen hier ihre echten Abos.';
    app.insertBefore(note, app.firstChild);
  }

  /* Fuer die Statistik wird die Lieferhistorie jedes Vertrags gebraucht. Vorab geholt wird sie nur fuer die
     ersten drei, deshalb hier nachladen und danach neu zeichnen. Laeuft nach dem ersten Zeichnen, blockiert
     die Seite also nicht. */
  function ensureStatsData() {
    if (!cfg.showStats || (cfg.orders || []).length) return;
    var jobs = [];
    (state.contracts || []).forEach(function (c) {
      var p = loadDetailData(c);
      if (p) jobs.push(p);
    });
    if (!jobs.length) return;
    /* Nicht neu zeichnen, solange ein Dialog offen ist: render() baut den Dialog neu auf und wuerde bereits
       ausgefuellte Eingaben verwerfen. Die Karte kommt dann beim naechsten regulaeren Zeichnen. */
    Promise.all(jobs).then(function () { if (!state.dialog) render(); }, function () {});
  }

  function init() {
    state.error = null; state.needsLogin = false;
    if (cfg.designMode) { loadDemo(); return; }
    resolveCustomer().then(loadAll).then(function () {
      var m = location.search.match(/[?&]abo=(\d+)/);
      var pre = m ? Number(m[1]) : (state.contracts.length === 1 ? state.contracts[0].id : null);
      var mt = location.search.match(/[?&]tab=(punkte|werben)/);
      if (pre && state.contracts.some(function (c) { return c.id === pre; })) {
        state.selectedId = pre;
        render();
        var p = loadDetailData(selected()); if (p) p.then(render);
      } else if (mt && loyOn()) {
        zeigeTab(mt[1]);
      } else {
        render();
      }
      ensureStatsData();
      /* Punktestand aus dem Metafeld kann ein paar Minuten alt sein: einmal frisch holen, leise nachzeichnen */
      if (loyOn()) loyLaden(false).then(function () { if (!state.dialog) render(); }, function () {});
    }, function (err) {
      var status = err && err.status;
      /* 401/403 = keine Kundensession. Alles andere (404, 5xx, HTML statt JSON) ist ein Verbindungs- oder Pfadproblem. */
      if (status === 401 || status === 403 || (!cfg.customerId && !status)) { state.needsLogin = true; render(); return; }
      if (status === 404 || (err && err.message && /<html|<!doctype/i.test(err.message))) {
        state.error = 'Appstle antwortet nicht unter „' + API_BASE + '“ (Status ' + (status || '?') + '). Bitte den App-Proxy-Pfad in den Section-Einstellungen prüfen.';
      } else {
        state.error = (err && err.message) || 'Unbekannter Fehler';
      }
      render();
    });
  }
  init();
}

  mount();
  /* Theme-Editor: nach jeder Einstellungsänderung wird die Section neu gerendert */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.rrp[data-section-id]')) mount();
  });
})();
